import React from "react";

export const LocationIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth="1.5"
		stroke="currentColor"
		className="w-6 h-6"
		{...props}
	>
		<path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
		/>
	</svg>
);

export const DprozLogoIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 867.82 391.5" {...props}>
		<g>
			<path d="M189.89,391.5c-5.01,0-10.03-.82-14.87-2.48-21.25-7.29-32.47-27.56-27.91-50.44.04-.2.08-.39.14-.59l20.85-77.69c-17.62,16.15-39.36,27.37-61.5,31.68-3.42.67-6.9,1.18-10.33,1.52-3.49.35-7.02.52-10.47.52-26.94,0-50.53-10.37-66.43-29.21C3.54,246.08-2.9,221.06,1.21,194.37c.02-.13.04-.27.07-.4l1.71-8.58c.03-.13.05-.26.09-.39,6.36-25.98,22.13-50.16,44.43-68.1,22.42-18.04,49.24-27.98,75.52-27.98,3.48,0,6.77.17,10.05.53.18.02.37.04.55.06l6.37-28.02,5.25-24.74c2.56-12.85,10.62-24.07,22.08-30.65,11.46-6.59,25.21-7.9,37.71-3.62,10.5,3.6,19.32,10.89,24.86,20.51,5.53,9.62,7.38,20.92,5.21,31.8l-15.93,76.38c13.16-14.9,31.06-29.02,53.46-33,5.48-.97,13.79-2.01,20.65-2.01,25.79,0,48.71,9.63,64.52,27.11,5.63,6.22,10.18,13.22,13.6,20.82,13.65-29.32,43.14-47.93,78.55-47.93h37.86c18.31,0,34.17,10.51,41.75,25.95,19.24-18.3,45.06-28.84,71.93-28.84,37.89,0,72.29,20.95,90.51,52.68l2.7-11.62c3.51-17.32,15.69-30.72,32.6-35.88,4.98-1.52,10.18-2.29,15.46-2.29h88.29c10.68,0,21.32,5.24,28.48,14.02,6.86,8.41,9.64,18.81,7.65,28.53l-6.96,33.97c-.63,3.05-1.72,6.06-3.35,9.22-2.31,4.46-5.32,8.24-8.97,11.25-.18.15-.37.29-.56.42l-19.3,13.58,18.55-.1h.05c2.75,0,5.35,1.23,7.1,3.35,1.76,2.13,2.47,4.95,1.93,7.66l-8.73,43.77c-3.19,16-13.64,28.62-28.66,34.64-6.1,2.44-12.63,3.68-19.42,3.68h-90.53c-3.9,0-7.81-.69-11.63-2.05-11.71-4.17-20.45-13.79-23.72-24.76-1.6,1.5-3.25,2.95-4.96,4.35-.05.05-.2.17-.34.29-.39.32-.84.67-1.3,1.02l-.42.32c-1,.79-2.06,1.6-3.13,2.38l-.64.45c-17.76,12.76-38.76,19.53-60.7,19.53-57.46,0-104.21-46.75-104.21-104.21,0-2.75.11-5.52.33-8.27l-9.75.05h-27.99c-3.75,0-7,2.67-7.74,6.34l-13.72,68.81c-4.74,23.75-27.28,39.75-51.36,36.42-12.28-1.7-23.07-8.3-30.38-18.58-5.17-7.27-8.15-15.86-8.71-24.67-24.04,27.2-58.29,43.69-91.9,43.69-3.59,0-6.98-.18-10.38-.56l-10.84,53.94c-2.58,12.95-10.64,24.17-22.1,30.76-7.02,4.04-14.91,6.1-22.84,6.1ZM165.11,342.46c-2.63,13.72,3.44,24.87,15.89,29.14,7.48,2.57,15.7,1.78,22.56-2.16,6.86-3.94,11.68-10.65,13.22-18.4l12.58-62.65c.48-2.41,1.91-4.53,3.96-5.88,2.05-1.35,4.56-1.83,6.97-1.32,5.46,1.15,10.32,1.67,15.76,1.67,31.62,0,64.08-17.5,84.71-45.67,4.08-5.56,11.33-7.51,17.64-4.73,6.33,2.78,9.8,9.46,8.45,16.24,0,.04-.04.19-.05.23-1.56,7.81.21,16.11,4.86,22.65,4.34,6.11,10.7,10.02,17.9,11.01,14.42,2,27.94-7.57,30.78-21.78l13.72-68.81c2.44-12.26,13.29-21.16,25.79-21.16h27.95s13.49-.06,13.49-.06h.07c5.43,0,10.39,2.54,13.62,6.97,1.43,1.96,2.03,4.4,1.66,6.8-.64,4.26-.97,8.61-.97,12.93,0,47.31,38.49,85.8,85.8,85.8,18.06,0,35.35-5.57,50-16.1l.5-.35c.87-.64,1.74-1.3,2.6-1.98l.52-.4c.32-.25.63-.49.94-.74.04-.03.14-.12.18-.16,8.59-7.08,15.56-15.54,20.78-25.21,2.14-3.96,6.83-5.8,11.1-4.33,4.26,1.47,6.83,5.8,6.08,10.24l-.46,2.72c-.04.22-.08.44-.14.66l-3.39,13.81c-1.44,7.53,4.32,16.34,12.67,19.31,1.83.65,3.67.98,5.46.98h90.53c4.43,0,8.66-.79,12.58-2.36,9.14-3.66,15.5-11.37,17.46-21.15l6.52-32.7-36.61.2h-.05c-4,0-7.55-2.59-8.77-6.4-1.22-3.83.18-8.02,3.47-10.33l42.98-30.25c1.61-1.38,2.98-3.16,4.09-5.29.84-1.63,1.39-3.09,1.67-4.46l6.96-33.96c.88-4.29-.53-9.1-3.88-13.2-3.7-4.54-9.02-7.24-14.22-7.24h-88.29c-3.45,0-6.85.5-10.09,1.49-10.52,3.21-17.79,11.23-19.95,22.02-.02.09-.04.19-.06.28l-9.45,40.67c-.97,4.17-4.69,7.12-8.97,7.12h-.05c-4.3-.03-8.01-3.02-8.94-7.22-8.59-38.97-43.82-67.25-83.77-67.25-27.08,0-52.89,13.02-69.02,34.84-2.32,3.13-6.35,4.47-10.09,3.33-3.73-1.14-6.34-4.51-6.5-8.41-.65-15.07-12.98-26.87-28.06-26.87h-37.86c-34.23,0-60.47,20.66-66.85,52.65l-4.79,24c-.96,4.82-5.52,8.03-10.39,7.31-4.86-.73-8.29-5.14-7.8-10.02,2.05-20.45-3.62-39.23-15.98-52.88-12.28-13.58-30.35-21.05-50.87-21.05-5.31,0-12.58.87-17.43,1.73-41.66,7.4-66.37,63.08-66.62,63.64-1.88,4.31-6.71,6.52-11.2,5.11-4.49-1.41-7.2-5.97-6.28-10.58l9.62-48.24,15.68-75.12c1.28-6.43.17-13.19-3.13-18.94-3.31-5.76-8.59-10.11-14.87-12.27-7.48-2.57-15.7-1.78-22.56,2.16-6.86,3.94-11.67,10.65-13.22,18.4l-5.3,24.97-8.31,36.59c-1.11,4.91-5.96,8.01-10.89,6.97-2.7-.57-5.21-.98-7.69-1.25-2.61-.28-5.25-.42-8.06-.42-22.09,0-44.81,8.49-63.97,23.91-19.1,15.37-32.61,35.94-38.04,57.94l-1.63,8.19c-3.23,21.28,1.76,41.01,14.05,55.58,12.34,14.62,30.94,22.67,52.36,22.67,2.85,0,5.77-.15,8.66-.43,2.86-.28,5.76-.71,8.62-1.27,19.49-3.8,38.71-13.96,54.12-28.62,1.41-1.34,3-2.42,4.73-3.22,6.53-3,13.92-1.88,19.27,2.91,5.28,4.72,7.22,11.8,5.11,18.53l-21.19,78.94ZM842.05,186.03h.02-.02Z" />
		</g>
	</svg>
);

export const SearchIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth="1.5"
		stroke="currentColor"
		className="w-6 h-6"
		{...props}
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
		/>
	</svg>
);

export const CalendarIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth="1.5"
		stroke="currentColor"
		className="w-6 h-6"
		{...props}
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
		/>
	</svg>
);

export const InfoCircle = (props) => (
	<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M7 5.25V7.4375M12.25 7C12.25 9.89949 9.89949 12.25 7 12.25C4.10051 12.25 1.75 9.89949 1.75 7C1.75 4.10051 4.10051 1.75 7 1.75C9.89949 1.75 12.25 4.10051 12.25 7ZM7 9.1875H7.00438V9.19188H7V9.1875Z"
			stroke="#333333"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const BookmarkIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth="1.5"
		stroke="currentColor"
		className="w-6 h-6"
		{...props}
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
		/>
	</svg>
);

export const GlobeIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth="1.5"
		stroke="currentColor"
		className="w-6 h-6"
		{...props}
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="m6.115 5.19.319 1.913A6 6 0 0 0 8.11 10.36L9.75 12l-.387.775c-.217.433-.132.956.21 1.298l1.348 1.348c.21.21.329.497.329.795v1.089c0 .426.24.815.622 1.006l.153.076c.433.217.956.132 1.298-.21l.723-.723a8.7 8.7 0 0 0 2.288-4.042 1.087 1.087 0 0 0-.358-1.099l-1.33-1.108c-.251-.21-.582-.299-.905-.245l-1.17.195a1.125 1.125 0 0 1-.98-.314l-.295-.295a1.125 1.125 0 0 1 0-1.591l.13-.132a1.125 1.125 0 0 1 1.3-.21l.603.302a.809.809 0 0 0 1.086-1.086L14.25 7.5l1.256-.837a4.5 4.5 0 0 0 1.528-1.732l.146-.292M6.115 5.19A9 9 0 1 0 17.18 4.64M6.115 5.19A8.965 8.965 0 0 1 12 3c1.929 0 3.716.607 5.18 1.64"
		/>
	</svg>
);

export const UsersIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth="1.5"
		stroke="currentColor"
		className="w-6 h-6"
		{...props}
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
		/>
	</svg>
);

export const BuildingIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth="1.5"
		stroke="currentColor"
		className="w-6 h-6"
		{...props}
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
		/>
	</svg>
);

export const MapPinIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth="1.5"
		stroke="currentColor"
		className="w-6 h-6"
		{...props}
	>
		<path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
		/>
	</svg>
);

export const BriefcaseIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth="1.5"
		stroke="currentColor"
		className="w-6 h-6"
		{...props}
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
		/>
	</svg>
);
export const CheckIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width="20"
		height="20"
		color="#000000"
		fill="none"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.75 22.5C5.81294 22.5 1 17.6871 1 11.75C1 5.81294 5.81294 1 11.75 1C17.6871 1 22.5 5.81294 22.5 11.75C22.5 17.6871 17.6871 22.5 11.75 22.5ZM16.5182 9.39018C16.8718 8.9659 16.8145 8.33534 16.3902 7.98177C15.9659 7.62821 15.3353 7.68553 14.9818 8.10981L10.6828 13.2686L8.45711 11.0429C8.06658 10.6524 7.43342 10.6524 7.04289 11.0429C6.65237 11.4334 6.65237 12.0666 7.04289 12.4571L10.0429 15.4571C10.2416 15.6558 10.5146 15.7617 10.7953 15.749C11.076 15.7362 11.3384 15.606 11.5182 15.3902L16.5182 9.39018Z"
			fill="currentColor"
		/>
	</svg>
);

export const Tick = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			d="M4.25 13.5L8.75 18L19.75 6"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const ChevronRightIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			d="M9.00005 6L15 12L9 18"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeMiterlimit="16"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export const Clock = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
			stroke="currentColor"
			strokeWidth="1.5"
		/>
		<path d="M12 8V12L14 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);
export const CircleIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
	</svg>
);

export const XIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			d="M19.0005 4.99988L5.00049 18.9999M5.00049 4.99988L19.0005 18.9999"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const XCircle = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			d="M15.5 15.5L8.50076 8.5M8.50151 15.5L15.5008 8.5"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const HelpCircle = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<circle
			cx="12"
			cy="12"
			r="10"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="square"
			strokeLinejoin="round"
		/>
		<path fillRule="evenodd" clipRule="evenodd" d="M12 16.5H12.009H12Z" fill="currentColor" />
		<path d="M12 16.5H12.009" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		<path
			d="M10 9.5C10 8.39543 10.8954 7.5 12 7.5C13.1046 7.5 14 8.39543 14 9.5C14 9.89815 13.8837 10.2691 13.6831 10.5808C13.0854 11.5097 12 12.3954 12 13.5"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
	</svg>
);
export const HomeIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M21.5315 10.5849L20.75 9.95977V18.9993C20.75 20.5181 19.5188 21.7493 18 21.7493H6.00003C4.48124 21.7493 3.25003 20.5181 3.25003 18.9993V9.95977L2.46855 10.5849C2.1451 10.8437 1.67313 10.7913 1.41438 10.4678C1.15562 10.1444 1.20806 9.6724 1.53151 9.41365L10.2821 2.41316C11.2865 1.60968 12.7136 1.60968 13.7179 2.41316L22.4685 9.41365C22.792 9.6724 22.8444 10.1444 22.5857 10.4678C22.3269 10.7913 21.855 10.8437 21.5315 10.5849ZM13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17V18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18V17Z"
			fill="currentColor"
		/>
	</svg>
);

export const DollarSign = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
			stroke="currentColor"
			strokeWidth="1.5"
		/>
		<path
			d="M14.7102 10.0611C14.6111 9.29844 13.7354 8.06622 12.1608 8.06619C10.3312 8.06616 9.56136 9.07946 9.40515 9.58611C9.16145 10.2638 9.21019 11.6571 11.3547 11.809C14.0354 11.999 15.1093 12.3154 14.9727 13.956C14.836 15.5965 13.3417 15.951 12.1608 15.9129C10.9798 15.875 9.04764 15.3325 8.97266 13.8733M11.9734 6.99805V8.06982M11.9734 15.9031V16.998"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
	</svg>
);
export const ChevronDown = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			d="M5.99977 9.00005L11.9998 15L17.9998 9"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeMiterlimit="16"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const LinkedInIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			d="M16 8C17.5913 8 19.1174 8.63214 20.2426 9.75736C21.3679 10.8826 22 12.4087 22 14V21H18V14C18 13.4696 17.7893 12.9609 17.4142 12.5858C17.0391 12.2107 16.5304 12 16 12C15.4696 12 14.9609 12.2107 14.5858 12.5858C14.2107 12.9609 14 13.4696 14 14V21H10V14C10 12.4087 10.6321 10.8826 11.7574 9.75736C12.8826 8.63214 14.4087 8 16 8Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path d="M6 9H2V21H6V9Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path
			d="M4 6C5.10457 6 6 5.10457 6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const TwitterIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			d="M22 4C22 4 21.3 6.1 20 7.4C21.6 17.4 10.6 24.7 2 19C4.2 19.1 6.4 18.4 8 17C3 15.5 0.5 9.6 3 5C5.2 7.6 8.6 9.1 12 9C11.1 4.8 16 2.4 19 5.2C20.1 5.2 22 4 22 4Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export const BellIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			d="M15 19C15 20.6569 13.6373 22 11.9759 22C10.3145 22 9 20.6569 9 19"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinejoin="round"
		/>
		<path
			d="M5 12V14L3 16.5V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V16.5L19 14V12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10.4387 3.31623L11 5H13L13.5613 3.31623C13.7771 2.6687 13.2951 2 12.6126 2H11.3874C10.7049 2 10.2229 2.6687 10.4387 3.31623Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const Trash = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			d="M19.5 5.5L18.6139 20.121C18.5499 21.1766 17.6751 22 16.6175 22H7.38246C6.32488 22 5.4501 21.1766 5.38612 20.121L4.5 5.5"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M3 5.5H8M21 5.5H16M16 5.5L14.7597 2.60608C14.6022 2.2384 14.2406 2 13.8406 2H10.1594C9.75937 2 9.39783 2.2384 9.24025 2.60608L8 5.5M16 5.5H8"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path d="M9.5 16.5L9.5 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path
			d="M14.5 16.5L14.5 10.5"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const Sort = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path d="M4 5L20 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M18 12L6 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M8 19L16 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export const Calendar = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			d="M3 9H21M7 3V5M17 3V5M6 13H8M6 17H8M11 13H13M11 17H13M16 13H18M16 17H18M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
	</svg>
);

export const Upload = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			d="M12 16.5V6.5M12 6.5L8.5 10M12 6.5L15.5 10"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M3 15.8C3 14.1198 3 13.2798 3.32698 12.638C3.6146 12.0735 4.07354 11.6146 4.63803 11.327C5.27976 11 6.11984 11 7.8 11H16.2C17.8802 11 18.7202 11 19.362 11.327C19.9265 11.6146 20.3854 12.0735 20.673 12.638C21 13.2798 21 14.1198 21 15.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15.8Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const UploadCircle = (props) => (
	<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width="36" height="36" rx="18" fill="#F0F7FF" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.25 25C11.0074 25 10 23.9926 10 22.75V17.25C10 16.0074 11.0074 15 12.25 15H14.25C14.6642 15 15 15.3358 15 15.75C15 16.1642 14.6642 16.5 14.25 16.5H12.25C11.8358 16.5 11.5 16.8358 11.5 17.25V22.75C11.5 23.1642 11.8358 23.5 12.25 23.5H23.75C24.1642 23.5 24.5 23.1642 24.5 22.75V17.25C24.5 16.8358 24.1642 16.5 23.75 16.5H21.75C21.3358 16.5 21 16.1642 21 15.75C21 15.3358 21.3358 15 21.75 15H23.75C24.9926 15 26 16.0074 26 17.25V22.75C26 23.9926 24.9926 25 23.75 25H12.25Z"
			fill="#2086FF"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18 22C17.5858 22 17.25 21.6642 17.25 21.25V11.7045L16.3075 12.7517C16.0304 13.0596 15.5562 13.0846 15.2483 12.8075C14.9404 12.5304 14.9154 12.0562 15.1925 11.7483L17.4425 9.24828C17.5848 9.09024 17.7874 9 18 9C18.2126 9 18.4152 9.09024 18.5575 9.24828L20.8075 11.7483C21.0846 12.0562 21.0596 12.5304 20.7517 12.8075C20.4438 13.0846 19.9696 13.0596 19.6925 12.7517L18.75 11.7045V21.25C18.75 21.6642 18.4142 22 18 22Z"
			fill="#2086FF"
		/>
	</svg>
);

export const Bell = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			d="M9 17.5V18.5C9 20.1569 10.3431 21.5 12 21.5C13.6569 21.5 15 20.1569 15 18.5V17.5M5.99999 8.5C5.99999 5.18629 8.68628 2.5 12 2.5C15.3137 2.5 18 5.18629 18 8.5V11.5C18 12.8261 18.6291 13.9271 19.2929 14.7574C19.6343 15.1795 19.8049 15.3905 19.8049 15.5C19.8049 15.6095 19.7839 15.6905 19.7418 15.7889C19.6997 15.8873 19.5906 16.0157 19.3723 16.2724C18.7529 16.9919 17.3483 17.5 12 17.5C6.65165 17.5 5.24714 16.9919 4.62771 16.2724C4.40938 16.0157 4.30022 15.8873 4.25814 15.7889C4.21606 15.6905 4.19507 15.6095 4.19507 15.5C4.19507 15.3905 4.36572 15.1795 4.70703 14.7574C5.37088 13.9271 5.99999 12.8261 5.99999 11.5V8.5Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const Circle = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.5" />
	</svg>
);

export const FileIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.19144 22.75C4.58211 22.75 3.27678 21.4403 3.27427 19.823L3.25 4.18619C3.24749 2.56532 4.55429 1.25 6.16717 1.25H12.9695C13.2271 1.25 13.4741 1.35268 13.6564 1.53551L20.4645 8.36329C20.6473 8.5466 20.75 8.79546 20.75 9.05498V19.8184C20.75 21.4375 19.4439 22.75 17.8328 22.75H6.19144ZM18.8043 9.46094L12.5673 3.20594V7.96094C12.5673 8.78936 13.2389 9.46094 14.0673 9.46094H18.8043ZM7.25391 18C7.25391 18.4142 7.58969 18.75 8.00391 18.75H16.0039C16.4181 18.75 16.7539 18.4142 16.7539 18C16.7539 17.5858 16.4181 17.25 16.0039 17.25H8.00391C7.58969 17.25 7.25391 17.5858 7.25391 18ZM8.00391 14.75C7.58969 14.75 7.25391 14.4142 7.25391 14C7.25391 13.5858 7.58969 13.25 8.00391 13.25H12.0039C12.4181 13.25 12.7539 13.5858 12.7539 14C12.7539 14.4142 12.4181 14.75 12.0039 14.75H8.00391Z"
			fill="currentColor"
		/>
	</svg>
);

export const FileOutlineIcon = (props) => (
	<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M9.33317 2.01294V4.76663C9.33317 5.14 9.33317 5.32669 9.40584 5.46929C9.46977 5.59473 9.5717 5.69672 9.69717 5.76064C9.83977 5.8333 10.0264 5.8333 10.3998 5.8333H13.1535M10.6665 9.16659H5.33317M10.6665 11.8333H5.33317M6.6665 6.49992H5.33317M9.33317 1.83325H5.8665C4.7464 1.83325 4.18634 1.83325 3.75852 2.05124C3.3822 2.24299 3.07624 2.54895 2.88449 2.92527C2.6665 3.35309 2.6665 3.91315 2.6665 5.03325V11.9666C2.6665 13.0867 2.6665 13.6467 2.88449 14.0746C3.07624 14.4509 3.3822 14.7569 3.75852 14.9486C4.18634 15.1666 4.7464 15.1666 5.8665 15.1666H10.1332C11.2533 15.1666 11.8133 15.1666 12.2412 14.9486C12.6175 14.7569 12.9234 14.4509 13.1152 14.0746C13.3332 13.6467 13.3332 13.0867 13.3332 11.9666V5.83325L9.33317 1.83325Z"
			stroke="#868E96"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const LinkIcon = (props) => (
	<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M6.6668 9.16675C6.95307 9.54948 7.31834 9.86615 7.73781 10.0953C8.15727 10.3245 8.62114 10.4608 9.09787 10.4949C9.57467 10.5291 10.0532 10.4603 10.501 10.2932C10.9489 10.1262 11.3555 9.86475 11.6935 9.52675L13.6935 7.52675C14.3007 6.89804 14.6366 6.05604 14.6291 5.18205C14.6215 4.30807 14.2709 3.47202 13.6529 2.85399C13.0348 2.23597 12.1988 1.88541 11.3248 1.87781C10.4508 1.87021 9.60881 2.2062 8.98014 2.81339L7.83347 3.95339M9.33347 7.83341C9.04714 7.45061 8.68187 7.13393 8.26241 6.90476C7.84294 6.67559 7.37914 6.53931 6.90234 6.50517C6.4256 6.47102 5.94707 6.53981 5.49923 6.70686C5.05139 6.87392 4.64472 7.13535 4.3068 7.47341L2.3068 9.47341C1.69961 10.1021 1.36362 10.9441 1.37122 11.8181C1.37881 12.6921 1.72937 13.5281 2.3474 14.1461C2.96543 14.7641 3.80147 15.1147 4.67546 15.1223C5.54945 15.1299 6.39145 14.7939 7.02014 14.1867L8.16014 13.0467"
			stroke="#868E96"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const CertificateIcon = (props) => (
	<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g clipPath="url(#clip0_1609_1237)">
			<path
				d="M4.33333 13.8333H3.33333C2.59695 13.8333 2 13.2363 2 12.4999V3.16659C2 2.43021 2.59695 1.83325 3.33333 1.83325H12.6667C13.4031 1.83325 14 2.43021 14 3.16659V12.4999C14 13.2363 13.4031 13.8333 12.6667 13.8333H11.6667M8 13.1666C9.1046 13.1666 10 12.2712 10 11.1666C10 10.062 9.1046 9.16659 8 9.16659C6.8954 9.16659 6 10.062 6 11.1666C6 12.2712 6.8954 13.1666 8 13.1666ZM8 13.1666L8.01427 13.1665L5.88578 15.295L4.00016 13.4093L6.0131 11.3964M8 13.1666L10.1285 15.295L12.0141 13.4093L10.0012 11.3964M6 4.49992H10M4.66667 6.83325H11.3333"
				stroke="#868E96"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1609_1237">
				<rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
			</clipPath>
		</defs>
	</svg>
);

export const DownloadIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
			stroke="currentColor"
			strokeWidth="1.5"
		/>
		<path
			d="M9.5 10.5L12 13L14.5 10.5M12 7V12.3912M8.99023 16H14.9902"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const AlertIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
		<path d="M12 8.5V12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path fillRule="evenodd" clipRule="evenodd" d="M12 15.5H12.009H12Z" fill="currentColor" />
		<path d="M12 15.5H12.009" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export const PreferencesIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.7224 1.25C9.96916 1.25 9.30042 1.732 9.06222 2.4466L8.37472 4.5091L7.31134 5.18166L5.06975 4.62702C4.32099 4.44175 3.53922 4.76857 3.1451 5.43163L1.78091 7.72672C1.35069 8.45051 1.4969 9.37806 2.12889 9.93442L3.6646 11.2863V12.7137L2.12936 14.0656C1.49752 14.622 1.35141 15.5494 1.78157 16.2732L3.14583 18.5684C3.53994 19.2314 4.32171 19.5582 5.07048 19.373L7.33457 18.8128L8.28531 19.3459L8.90518 21.4867C9.12185 22.235 9.80709 22.75 10.5861 22.75H13.4179C14.197 22.75 14.8822 22.235 15.0989 21.4867L15.7188 19.3458L16.6688 18.8128L18.9328 19.373C19.6816 19.5582 20.4634 19.2314 20.8575 18.5684L22.2475 16.2298C22.6571 15.5406 22.5461 14.6612 21.9779 14.0955L20.3927 12.5172L20.3931 11.4831L21.9786 9.90447C22.5468 9.33878 22.6579 8.45936 22.2482 7.77018L20.8582 5.43163C20.4641 4.76857 19.6823 4.44175 18.9336 4.62702L16.692 5.18166L15.6286 4.5091L14.9411 2.4466C14.7029 1.732 14.0341 1.25 13.2809 1.25L10.7224 1.25ZM12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5Z"
			fill="currentColor"
		/>
	</svg>
);

export const JobsIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.13743 3.71716C8.27819 2.73186 9.12203 2 10.1173 2H14.3827C15.378 2 16.2219 2.73186 16.3626 3.71716L16.74 6.35858C16.8181 6.90531 16.4382 7.41184 15.8915 7.48995C15.3447 7.56805 14.8382 7.18816 14.7601 6.64142L14.3827 4H10.1173L9.73999 6.64142C9.66188 7.18816 9.15535 7.56805 8.60861 7.48995C8.06188 7.41184 7.68198 6.90531 7.76009 6.35858L8.13743 3.71716Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.75003 5.75C2.78353 5.75 2.00003 6.5335 2.00003 7.5V10.4567C2.00003 10.6758 2.04107 10.9068 2.137 11.1271C3.80107 14.9479 8.45353 16.386 12.6604 16.2398C14.8004 16.1654 16.9291 15.6848 18.6707 14.8305C20.4029 13.9808 21.834 12.7175 22.4131 11.035C22.4764 10.851 22.5 10.6679 22.5 10.4996V7.5C22.5 6.5335 21.7165 5.75 20.75 5.75H3.75003ZM12.25 10.5C11.6977 10.5 11.25 10.9477 11.25 11.5C11.25 12.0523 11.6977 12.5 12.25 12.5H12.259C12.8113 12.5 13.259 12.0523 13.259 11.5C13.259 10.9477 12.8113 10.5 12.259 10.5H12.25Z"
			fill="currentColor"
		/>
		<path
			d="M3.00003 14.7803V19.9995C3.00003 21.5183 4.23125 22.7495 5.75003 22.7495H18.75C20.2688 22.7495 21.5 21.5183 21.5 19.9995V14.7884C20.8339 15.3433 20.092 15.8036 19.3313 16.1767C17.3695 17.1391 15.0272 17.658 12.7125 17.7384C9.46184 17.8514 5.61441 17.0771 3.00003 14.7803Z"
			fill="currentColor"
		/>
	</svg>
);

export const DocumentIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.50017 1.25C3.9814 1.25 2.75018 2.4812 2.75017 3.99998L2.75003 20C2.75002 21.5188 3.98124 22.75 5.50003 22.75H12.9549C12.3611 22.0866 12 21.2104 12 20.25V16.75C12 15.3611 12.6299 14.0773 13.4977 13.1641C14.3804 12.2351 15.6917 11.5 17.25 11.5C18.8084 11.5 20.1196 12.2351 21.0024 13.1641C21.0873 13.2534 21.17 13.3464 21.25 13.4426V4C21.25 2.48122 20.0188 1.25 18.5 1.25H5.50017ZM6.75003 6C6.75003 5.58579 7.08582 5.25 7.50003 5.25H16.5C16.9142 5.25 17.25 5.58579 17.25 6C17.25 6.41421 16.9142 6.75 16.5 6.75H7.50003C7.08582 6.75 6.75003 6.41421 6.75003 6ZM7.50003 9.25C7.08582 9.25 6.75003 9.58579 6.75003 10C6.75003 10.4142 7.08582 10.75 7.50003 10.75H13.5C13.9142 10.75 14.25 10.4142 14.25 10C14.25 9.58579 13.9142 9.25 13.5 9.25H7.50003Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.4038 14.0251C15.098 13.2945 16.0976 12.75 17.25 12.75C18.4024 12.75 19.402 13.2945 20.0962 14.0251C20.7838 14.7486 21.25 15.7359 21.25 16.75V19.75C21.25 20.3023 20.8023 20.75 20.25 20.75C19.6977 20.75 19.25 20.3023 19.25 19.75L19.25 16.75C19.25 16.3346 19.0447 15.8219 18.6464 15.4028C18.2549 14.9908 17.7544 14.75 17.25 14.75C16.7456 14.75 16.2451 14.9908 15.8536 15.4028C15.4553 15.8219 15.25 16.3346 15.25 16.75V20.25C15.25 20.5261 15.4739 20.75 15.75 20.75C16.0261 20.75 16.25 20.5261 16.25 20.25V16.75C16.25 16.1977 16.6977 15.75 17.25 15.75C17.8023 15.75 18.25 16.1977 18.25 16.75V20.25C18.25 21.6307 17.1307 22.75 15.75 22.75C14.3693 22.75 13.25 21.6307 13.25 20.25L13.25 16.75C13.25 15.7359 13.7162 14.7486 14.4038 14.0251Z"
			fill="currentColor"
		/>
	</svg>
);

export const OutlinedDocumentIcon = (props) => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width="40" height="40" rx="20" fill="#F9FAFB" />
		<path
			d="M28 15V14.8C28 13.1198 28 12.2798 27.673 11.638C27.3854 11.0735 26.9265 10.6146 26.362 10.327C25.7202 10 24.8802 10 23.2 10H16.8C15.1198 10 14.2798 10 13.638 10.327C13.0735 10.6146 12.6146 11.0735 12.327 11.638C12 12.2798 12 13.1198 12 14.8V25.2C12 26.8802 12 27.7202 12.327 28.362C12.6146 28.9265 13.0735 29.3854 13.638 29.673C14.2798 30 15.1198 30 16.8 30H20.5M20.5 19H16M19.5 23H16M24 15H16M26 26V20.5C26 19.6716 26.6716 19 27.5 19C28.3284 19 29 19.6716 29 20.5V26C29 27.6569 27.6569 29 26 29C24.3431 29 23 27.6569 23 26V22"
			stroke="#6E7889"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const ResumeIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.1716 1.25C14.1978 1.25 14.2239 1.25037 14.25 1.25112V5.99958C14.25 6.96607 15.0335 7.74957 16 7.74958L20.7489 7.74964C20.7496 7.77586 20.75 7.80212 20.75 7.82843V20C20.75 21.5188 19.5188 22.75 18 22.75H6C4.48122 22.75 3.25 21.5188 3.25 20V4C3.25 2.48122 4.48122 1.25 6 1.25H14.1716ZM19.9445 5.88388C20.0581 5.99744 20.1607 6.1199 20.2517 6.24963L16 6.24958C15.8619 6.24958 15.75 6.13765 15.75 5.99958V1.74808C15.8799 1.83911 16.0025 1.94179 16.1161 2.05546L19.9445 5.88388ZM8 10.25C7.58579 10.25 7.25 10.5858 7.25 11C7.25 11.4142 7.58579 11.75 8 11.75H16C16.4142 11.75 16.75 11.4142 16.75 11C16.75 10.5858 16.4142 10.25 16 10.25H8ZM8 13.25C7.58579 13.25 7.25 13.5858 7.25 14C7.25 14.4142 7.58579 14.75 8 14.75H16C16.4142 14.75 16.75 14.4142 16.75 14C16.75 13.5858 16.4142 13.25 16 13.25H8ZM8 16.25C7.58579 16.25 7.25 16.5858 7.25 17C7.25 17.4142 7.58579 17.75 8 17.75H12.1708C12.585 17.75 12.9208 17.4142 12.9208 17C12.9208 16.5858 12.585 16.25 12.1708 16.25H8Z"
			fill="currentColor"
		/>
	</svg>
);

export const FiltersIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" {...props}>
		<path
			d="M19.5 2.5C20.6046 2.5 21.5 3.39543 21.5 4.5V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5L2.5 4.5C2.5 3.39543 3.39543 2.5 4.5 2.5L19.5 2.5Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinejoin="round"
		/>
		<path
			d="M16 14C16.5523 14 17 14.4477 17 15L17 16C17 16.5523 16.5523 17 16 17L15 17C14.4477 17 14 16.5523 14 16L14 15C14 14.4477 14.4477 14 15 14L16 14Z"
			stroke="currentColor"
			strokeWidth="1.5"
		/>
		<path
			d="M9 7C9.55228 7 10 7.44772 10 8L10 9C10 9.55228 9.55228 10 9 10L8 10C7.44772 10 7 9.55228 7 9L7 8C7 7.44772 7.44772 7 8 7L9 7Z"
			stroke="currentColor"
			strokeWidth="1.5"
		/>
		<path d="M7.5 15.5H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M10.5 8.5H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export const VerticalFiltersIcon = (props) => (
	<svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x="0.5" width="40" height="40" rx="20" fill="#F9FAFB" />
		<path
			d="M15 21.5L15 11.75M15 21.5C15.8284 21.5 16.5 22.1716 16.5 23C16.5 23.8284 15.8284 24.5 15 24.5M15 21.5C14.1716 21.5 13.5 22.1716 13.5 23C13.5 23.8284 14.1716 24.5 15 24.5M15 28.25L15 24.5M27 21.5V11.75M27 21.5C27.8284 21.5 28.5 22.1716 28.5 23C28.5 23.8284 27.8284 24.5 27 24.5M27 21.5C26.1716 21.5 25.5 22.1716 25.5 23C25.5 23.8284 26.1716 24.5 27 24.5M27 28.25L27 24.5M21 15.5V11.75M21 15.5C21.8284 15.5 22.5 16.1716 22.5 17C22.5 17.8284 21.8284 18.5 21 18.5M21 15.5C20.1716 15.5 19.5 16.1716 19.5 17C19.5 17.8284 20.1716 18.5 21 18.5M21 28.25V18.5"
			stroke="#6E7889"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const ClipIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" {...props}>
		<path
			d="M5.82338 12L4.27922 10.4558C2.57359 8.75022 2.57359 5.98485 4.27922 4.27922C5.98485 2.57359 8.75022 2.57359 10.4558 4.27922L19.7208 13.5442C21.4264 15.2498 21.4264 18.0152 19.7208 19.7208C18.0152 21.4264 15.2498 21.4264 13.5442 19.7208L10.0698 16.2464C9.00379 15.1804 9.00379 13.4521 10.0698 12.386C11.1358 11.32 12.8642 11.32 13.9302 12.386L15.8604 14.3162"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const Feeling1 = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
			fill="#FFDD67"
		/>
		<path
			d="M7.40002 11.8398C8.50459 11.8398 9.40002 10.9444 9.40002 9.83984C9.40002 8.73527 8.50459 7.83984 7.40002 7.83984C6.29545 7.83984 5.40002 8.73527 5.40002 9.83984C5.40002 10.9444 6.29545 11.8398 7.40002 11.8398Z"
			fill="#664E27"
		/>
		<path
			d="M16.6001 11.8398C17.7047 11.8398 18.6001 10.9444 18.6001 9.83984C18.6001 8.73527 17.7047 7.83984 16.6001 7.83984C15.4955 7.83984 14.6001 8.73527 14.6001 9.83984C14.6001 10.9444 15.4955 11.8398 16.6001 11.8398Z"
			fill="#664E27"
		/>
		<path
			d="M17.0401 15.32C13.8001 17.6 10.2001 17.56 6.96013 15.32C6.56013 15.04 6.24013 15.52 6.48013 15.96C7.48013 17.56 9.44013 19.04 12.0001 19.04C14.5601 19.04 16.5201 17.6 17.5201 15.96C17.7601 15.52 17.4401 15.04 17.0401 15.32Z"
			fill="#664E27"
		/>
	</svg>
);

export const Feeling2 = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M0 12C0 18.64 5.36 24 12 24C18.64 24 24 18.64 24 12C24 5.36 18.64 0 12 0C5.36 0 0 5.36 0 12Z"
			fill="#FFDD67"
		/>
		<path
			d="M18.28 14.2397C18.28 17.6797 22.96 17.6797 22.96 14.2397C22.96 11.7197 20.64 9.27966 20.64 9.27966C20.64 9.27966 18.28 11.7197 18.28 14.2397Z"
			fill="#65B1EF"
		/>
		<path
			d="M14.6 15.2006C15.7045 15.2006 16.6 14.3051 16.6 13.2006C16.6 12.096 15.7045 11.2006 14.6 11.2006C13.4954 11.2006 12.6 12.096 12.6 13.2006C12.6 14.3051 13.4954 15.2006 14.6 15.2006Z"
			fill="#664E27"
		/>
		<path
			d="M5.40002 15.2006C6.50459 15.2006 7.40002 14.3051 7.40002 13.2006C7.40002 12.096 6.50459 11.2006 5.40002 11.2006C4.29545 11.2006 3.40002 12.096 3.40002 13.2006C3.40002 14.3051 4.29545 15.2006 5.40002 15.2006Z"
			fill="#664E27"
		/>
		<path
			d="M7.43998 7.16008C6.15998 8.24008 4.43998 8.72008 2.75998 8.40008C2.51998 8.36008 2.31998 9.20008 2.59998 9.28008C4.51998 9.64008 6.51998 9.08008 7.99998 7.84008C8.19998 7.64008 7.59998 7.00008 7.43998 7.16008ZM17.24 8.36008C15.56 8.64008 13.84 8.20008 12.56 7.12008C12.4 6.96008 11.76 7.60008 12 7.80008C13.48 9.08008 15.48 9.60008 17.4 9.24008C17.68 9.16008 17.48 8.32008 17.24 8.36008Z"
			fill="#917524"
		/>
		<path
			d="M14.44 18.1201C12.12 17.5201 9.64004 17.9601 7.68004 19.3201C7.20004 19.6801 8.12004 20.9201 8.60004 20.6001C9.88004 19.6801 11.96 19.0801 14.08 19.6401C14.6 19.7601 15.04 18.3201 14.44 18.1201Z"
			fill="#664E27"
		/>
	</svg>
);

export const Feeling3 = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
			fill="#FFDD67"
		/>
		<path
			d="M8.24002 6.48057C6.96002 7.56057 5.24002 8.04057 3.56002 7.72057C3.32002 7.68057 3.12002 8.52057 3.40002 8.60057C5.32002 8.96057 7.32002 8.40057 8.80002 7.16057C9.00002 6.96057 8.40002 6.32057 8.24002 6.48057ZM20.44 7.68057C18.76 7.96057 17.04 7.52057 15.76 6.44057C15.6 6.28057 14.96 6.92057 15.2 7.12057C16.68 8.40057 18.68 8.92057 20.6 8.56057C20.88 8.48057 20.68 7.64057 20.44 7.68057Z"
			fill="#917524"
		/>
		<path
			d="M17.84 16.1602C17.64 15.9202 17.24 15.8402 16.96 16.0402L15.28 17.1602C15 17.3602 14.56 17.3202 14.32 17.1202L12.48 15.5602C12.24 15.3602 11.84 15.3602 11.56 15.5602L9.72003 17.1202C9.48003 17.3202 9.04003 17.3602 8.76003 17.1602L7.04003 16.0402C6.76003 15.8402 6.36003 15.9202 6.16003 16.1602L4.40003 18.2402C4.20003 18.4802 4.24003 18.5602 4.52003 18.4002L6.04003 17.5602C6.32003 17.4002 6.76003 17.4402 7.00003 17.6802L8.84003 19.4802C9.08003 19.7202 9.48003 19.7202 9.76003 19.5202L11.56 18.1602C11.84 17.9602 12.24 17.9602 12.52 18.1602L14.28 19.5202C14.56 19.7202 14.96 19.6802 15.2 19.4802L17.04 17.6802C17.28 17.4402 17.72 17.4002 18 17.5602L19.52 18.4002C19.8 18.5602 19.88 18.4802 19.64 18.2402L17.84 16.1602ZM19.88 10.4402C20.12 10.5602 20 10.8402 19.8 10.8802C18.72 11.0402 17.6 11.2402 16.48 11.8402C18.08 12.1202 19.36 12.9202 20.08 13.7602C20.24 13.9602 20.04 14.2002 19.88 14.1602C17.96 13.4802 16 13.0802 13.56 13.3602C13.36 13.3602 13.2 13.2802 13.24 13.0802C13.88 10.1602 17.6 9.0802 19.88 10.4402ZM4.12003 10.4402C3.88003 10.5602 4.00003 10.8402 4.20003 10.8802C5.28003 11.0402 6.40003 11.2402 7.52003 11.8402C5.92003 12.1202 4.64003 12.9202 3.92003 13.7602C3.76003 13.9602 3.96003 14.2002 4.12003 14.1602C6.04003 13.4802 8.00003 13.0802 10.44 13.3602C10.64 13.3602 10.8 13.2802 10.76 13.0802C10.12 10.1602 6.40003 9.0802 4.12003 10.4402Z"
			fill="#664E27"
		/>
	</svg>
);

export const Feeling4 = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M24 12C24 18.64 18.64 24 12 24C5.36 24 0 18.64 0 12C0 5.36 5.36 0 12 0C18.64 0 24 5.36 24 12Z"
			fill="#FFDD67"
		/>
		<path
			d="M18.5601 4.35964C16.8801 4.51964 15.3201 5.39964 14.3601 6.79964C14.2401 6.99964 13.4801 6.51964 13.6401 6.27964C14.7601 4.67965 16.5201 3.63964 18.4801 3.47964C18.7601 3.47964 18.8001 4.35964 18.5601 4.35964ZM9.64006 6.79964C8.68006 5.39964 7.12006 4.51964 5.44006 4.35964C5.20006 4.35964 5.24006 3.47964 5.52006 3.47964C7.48006 3.63964 9.24006 4.67965 10.3601 6.27964C10.5201 6.51964 9.76006 6.99964 9.64006 6.79964Z"
			fill="#917524"
		/>
		<path
			d="M7.68001 15.1598C10.48 13.2398 13.56 13.2398 16.32 15.1598C16.64 15.3998 16.96 14.9998 16.72 14.6398C15.88 13.2798 14.16 12.0398 12 12.0398C9.84001 12.0398 8.12001 13.2798 7.28001 14.6398C7.04001 14.9998 7.36001 15.3998 7.68001 15.1598ZM13.56 7.5998C15.24 10.7998 18.64 10.7998 20.32 7.5998C20.4 7.4398 20.2 7.3598 19.92 7.1998C18.24 8.5198 15.48 8.3998 13.96 7.1998C13.72 7.3998 13.48 7.4398 13.56 7.5998ZM3.68001 7.5998C5.36001 10.7998 8.76001 10.7998 10.44 7.5998C10.52 7.4398 10.32 7.3598 10.04 7.1998C8.36001 8.5198 5.60001 8.3998 4.08001 7.1998C3.80001 7.3998 3.60001 7.4398 3.68001 7.5998Z"
			fill="#664E27"
		/>
		<path
			d="M23.88 18.1203C23.48 17.1203 22.16 16.6003 20.96 16.9203C20.32 17.0803 19.84 17.4403 19.6 17.8803C16.48 17.2803 13.6 11.7203 13.6 11.7203C13.6 11.7203 13.68 16.2403 15.96 18.8803C15.48 18.7203 14.96 18.7203 14.4 18.8403C13.16 19.1603 12.52 20.2403 12.92 21.2003C13.32 22.1603 14.64 22.7203 15.84 22.4003C15.92 22.3603 16 22.3603 16.08 22.3203C16.72 23.5603 18.44 24.2003 20.08 23.8003C21.8 23.3603 22.72 21.8803 22.16 20.5203C22.24 20.5203 22.32 20.4803 22.4 20.4803C23.6 20.2003 24.28 19.1203 23.88 18.1203ZM0.119956 18.1203C0.519956 17.1203 1.83996 16.6003 3.03996 16.9203C3.67996 17.0803 4.15996 17.4403 4.39996 17.8803C7.51996 17.2803 10.4 11.7203 10.4 11.7203C10.4 11.7203 10.32 16.2403 8.03996 18.8803C8.51996 18.7203 9.03996 18.7203 9.59996 18.8403C10.84 19.1603 11.48 20.2403 11.08 21.2003C10.68 22.2003 9.35995 22.7203 8.15996 22.4003C8.07996 22.3603 7.99996 22.3603 7.91996 22.3203C7.27996 23.5603 5.55996 24.2003 3.91996 23.8003C2.19996 23.3603 1.27996 21.8803 1.83996 20.5203C1.75996 20.5203 1.67996 20.4803 1.59996 20.4803C0.399956 20.2003 -0.280044 19.1203 0.119956 18.1203Z"
			fill="#D8D8D8"
		/>
		<path
			d="M22.92 17.1206C22.56 16.0806 21.36 15.4806 20.2 15.8406C19.64 16.0006 19.2 16.4006 18.92 16.8806C16.04 16.2406 13.4 10.3206 13.4 10.3206C13.4 10.3206 13.52 15.1606 15.6 18.0006C15.16 17.8406 14.68 17.8406 14.2 17.9606C13.08 18.3206 12.48 19.4406 12.84 20.4806C13.2 21.5206 14.4 22.1206 15.56 21.7606C15.64 21.7206 15.72 21.7206 15.8 21.6806C16.4 23.0006 18 23.7206 19.48 23.2406C21.04 22.7606 21.92 21.2006 21.4 19.7206C21.48 19.7206 21.56 19.6806 21.64 19.6806C22.68 19.3206 23.32 18.2006 22.92 17.1206ZM1.08004 17.1206C1.44004 16.0806 2.64004 15.4806 3.80004 15.8406C4.36004 16.0006 4.80004 16.4006 5.04004 16.8806C7.92004 16.2406 10.56 10.3206 10.56 10.3206C10.56 10.3206 10.48 15.1606 8.40004 18.0006C8.84004 17.8406 9.32004 17.8406 9.80004 17.9606C10.92 18.3206 11.56 19.4406 11.16 20.4806C10.8 21.5206 9.60004 22.1206 8.44004 21.7606C8.36004 21.7206 8.28004 21.7206 8.20004 21.6806C7.60004 23.0006 6.00004 23.7206 4.52004 23.2406C3.00004 22.8006 2.16004 21.2006 2.68004 19.7206C2.60004 19.7206 2.52004 19.6806 2.44004 19.6806C1.32004 19.3206 0.68004 18.2006 1.08004 17.1206Z"
			fill="white"
		/>
	</svg>
);

export const Feeling5 = (props) => (
	<svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M0 12C0 18.6429 5.35714 24 12 24C18.6429 24 24 18.6429 24 12C24 5.35714 18.6429 0 12 0C5.35714 0 0 5.35714 0 12Z"
			fill="#FFDD67"
		/>
		<path
			d="M4.37139 4.2857C5.82854 3.42856 7.58568 3.29999 9.21425 3.85713C9.42854 3.94284 9.77139 3.12856 9.51425 3.04285C7.67139 2.35713 5.65711 2.52856 3.94282 3.51427C3.68568 3.64284 4.15711 4.41427 4.37139 4.2857ZM14.6571 5.57142C16.1143 4.71427 17.8714 4.5857 19.5 5.14285C19.7142 5.22856 20.0571 4.41427 19.8 4.32856C17.9571 3.64285 15.9428 3.81427 14.2285 4.79999C13.9714 4.92856 14.4428 5.65713 14.6571 5.57142Z"
			fill="#917524"
		/>
		<path
			d="M8.61432 14.0141C10.8 13.457 13.2 13.8427 15.0429 15.1284C15.5143 15.4284 14.6572 16.6284 14.1857 16.2855C12.9429 15.4713 11.0143 14.8713 9.00004 15.3855C8.48575 15.5141 8.05718 14.1855 8.61432 14.0141Z"
			fill="#664E27"
		/>
		<path
			d="M16.6286 11.6142C14.8714 11.6142 13.4143 10.157 13.4143 8.3999C13.4143 7.67133 13.6714 6.98561 14.0572 6.47133C14.7857 6.25704 15.6 6.17133 16.4572 6.17133C17.4857 6.17133 18.4714 6.34275 19.3286 6.64275C19.6714 7.15704 19.8857 7.75704 19.8857 8.44275C19.8429 10.1999 18.4286 11.6142 16.6286 11.6142Z"
			fill="white"
		/>
		<path
			d="M17.0571 6.17133C17.2285 6.42847 17.3571 6.72847 17.3571 7.07133C17.3571 7.97133 16.6285 8.6999 15.7285 8.6999C14.8285 8.6999 14.1428 7.97133 14.1428 7.11418C14.1428 6.85704 14.1857 6.64275 14.3143 6.42847C14.9571 6.25704 15.6857 6.17133 16.4571 6.17133H17.0571Z"
			fill="#664E27"
		/>
		<path
			d="M7.37139 11.6142C5.61425 11.6142 4.1571 10.157 4.1571 8.3999C4.1571 7.67133 4.41425 6.98561 4.79996 6.47133C5.52853 6.25704 6.34282 6.17133 7.19996 6.17133C8.22853 6.17133 9.21425 6.34275 10.0714 6.64275C10.4142 7.15704 10.6285 7.75704 10.6285 8.44275C10.5857 10.1999 9.12853 11.6142 7.37139 11.6142Z"
			fill="white"
		/>
		<path
			d="M7.80004 6.17149C7.97147 6.42863 8.10004 6.72863 8.10004 7.07149C8.10004 7.97149 7.37147 8.70006 6.47147 8.70006C5.57147 8.70006 4.8429 7.97149 4.8429 7.07149C4.8429 6.81435 4.88575 6.60006 5.01432 6.38577C5.65718 6.21435 6.38575 6.12863 7.15718 6.12863C7.41432 6.17149 7.58575 6.17149 7.80004 6.17149Z"
			fill="#664E27"
		/>
		<path
			d="M12.2571 18.0002C10.4572 18.4287 5.87144 18.9859 5.05715 18.1287C4.67144 17.743 4.75715 17.1859 4.88572 16.2002C5.01429 15.2144 4.07144 14.1859 3.38572 14.1002C2.57144 14.0144 2.10001 14.6144 2.40001 15.4716C3.00001 17.4002 1.80001 18.0002 1.71429 19.4144C1.67144 20.2287 1.41429 21.6002 2.65715 23.3573C4.07144 25.3287 6.51429 25.3716 7.37144 25.3287C8.35715 25.2859 8.78572 25.243 9.00001 24.8144C9.25715 24.3002 9.12858 24.1716 9.25715 24.0002C9.47144 23.6144 9.60001 23.6573 9.72858 23.1859C9.85715 22.7144 9.51429 22.4144 9.60001 22.2002C9.77144 21.6859 10.2 21.7716 9.77144 20.5716C11.2286 20.3573 12.1714 20.143 13.0286 19.6287C14.6143 18.7716 13.2429 17.7859 12.2571 18.0002Z"
			fill="white"
		/>
		<path
			d="M5.78571 25.5858C4.32856 25.3287 3.12856 24.6001 2.35714 23.5287C1.15714 21.8573 1.24285 20.5287 1.32856 19.6287V19.3287C1.37142 18.7287 1.54285 18.2573 1.75714 17.7858C2.05714 17.1001 2.31428 16.543 1.97142 15.5144C1.79999 15.0001 1.84285 14.4858 2.18571 14.143C2.48571 13.843 2.91428 13.6715 3.42856 13.7573H3.47142C4.37142 13.9287 5.39999 15.1287 5.27142 16.2858C5.14285 17.2287 5.09999 17.6573 5.35714 17.9144C5.39999 17.9573 5.52856 18.0858 5.99999 18.1287C7.62856 18.4287 10.8429 17.9573 12.1714 17.6573C12.3857 17.6144 12.6428 17.6144 12.9 17.6573C13.5428 17.7858 14.0143 18.1715 14.1428 18.643C14.1857 18.943 14.1857 19.5001 13.2857 20.0144C12.4286 20.4858 11.5286 20.743 10.2857 20.9144C10.6286 21.7715 9.81428 22.0715 9.98571 22.4144C10.2 22.8858 10.1571 23.2715 9.68571 23.743C9.34285 24.043 9.77142 24.4287 9.42856 25.0287C9.04285 25.6715 8.39999 25.7144 7.45714 25.7573C6.81428 25.7144 6.29999 25.7144 5.78571 25.5858ZM2.52856 15.0858C2.82856 16.5001 2.91428 17.0144 2.39999 18.1715C1.62856 19.7144 1.32856 24.0858 5.91428 24.9001C8.69999 25.4144 9.12856 24.7287 8.99999 24.0001C8.91428 23.5287 9.29999 23.3573 9.42856 23.1858C9.72856 22.6715 9.29999 22.4144 9.29999 22.2001C9.29999 21.8144 9.68571 21.8144 9.77142 21.4287C9.89999 20.743 9.04285 20.4858 9.77142 20.443C11.1857 20.3573 12.1286 20.1001 12.9429 19.543C13.7143 19.0287 13.1571 17.9573 12.1286 18.1715C9.72856 18.6858 6.12856 19.2858 4.92856 18.1715C4.37142 17.6573 4.79999 17.0573 4.75714 15.9001C4.67142 14.3573 2.22856 13.7573 2.52856 15.0858Z"
			fill="#CCCFD4"
		/>
	</svg>
);

export const Feeling6 = (props) => (
	<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M0 12.7573C0 19.3973 5.36 24.7573 12 24.7573C18.64 24.7573 24 19.3973 24 12.7573C24 6.11726 18.64 0.757263 12 0.757263C5.36 0.757263 0 6.11726 0 12.7573Z"
			fill="#FFDD67"
		/>
		<path
			d="M18.6 6.47726C18.6 10.4373 24 10.4373 24 6.47726C24 3.59726 21.32 0.757263 21.32 0.757263C21.32 0.757263 18.6 3.59726 18.6 6.47726Z"
			fill="#65B1EF"
		/>
		<path
			d="M16.6 16.3578C17.7045 16.3578 18.6 15.4624 18.6 14.3578C18.6 13.2533 17.7045 12.3578 16.6 12.3578C15.4954 12.3578 14.6 13.2533 14.6 14.3578C14.6 15.4624 15.4954 16.3578 16.6 16.3578Z"
			fill="#664E27"
		/>
		<path
			d="M7.40002 16.3578C8.50459 16.3578 9.40002 15.4624 9.40002 14.3578C9.40002 13.2533 8.50459 12.3578 7.40002 12.3578C6.29545 12.3578 5.40002 13.2533 5.40002 14.3578C5.40002 15.4624 6.29545 16.3578 7.40002 16.3578Z"
			fill="#664E27"
		/>
		<path
			d="M9.43998 8.71708C8.15998 9.79708 6.43998 10.2771 4.75998 9.95708C4.51998 9.91708 4.31998 10.7571 4.59998 10.8371C6.51998 11.1971 8.51998 10.6371 9.99998 9.39708C10.2 9.19708 9.59998 8.55708 9.43998 8.71708ZM19.24 9.91708C17.56 10.1971 15.84 9.75708 14.56 8.67708C14.4 8.51708 13.76 9.15708 14 9.35708C15.48 10.6371 17.48 11.1571 19.4 10.7971C19.68 10.7171 19.48 9.87708 19.24 9.91708Z"
			fill="#917524"
		/>
		<path
			d="M15.2 20.7569H8.79998C8.19998 20.7569 8.19998 19.1569 8.79998 19.1569H15.2C15.8 19.1569 15.8 20.7569 15.2 20.7569Z"
			fill="#664E27"
		/>
	</svg>
);

export const Feeling7 = (props) => (
	<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M12 24.7573C18.6274 24.7573 24 19.3847 24 12.7573C24 6.12985 18.6274 0.757263 12 0.757263C5.37258 0.757263 0 6.12985 0 12.7573C0 19.3847 5.37258 24.7573 12 24.7573Z"
			fill="#FFDD67"
		/>
		<path
			d="M9.40001 11.3174C9.96001 12.4774 9.24001 13.9574 7.84001 14.6374C6.44001 15.2774 4.84001 14.8774 4.28001 13.7174C3.96001 12.9574 9.08001 10.5574 9.40001 11.3174ZM14.6 11.3174C14.04 12.4774 14.76 13.9574 16.16 14.6374C17.56 15.2774 19.16 14.8774 19.72 13.7174C20.04 12.9574 14.92 10.5574 14.6 11.3174Z"
			fill="#664E27"
		/>
		<path
			d="M8.27998 7.87741C7.19998 9.19741 4.59998 10.3974 2.87998 10.3974C2.63998 10.3974 2.59998 11.2774 2.87998 11.2774C4.83998 11.2774 7.67998 9.95741 8.95998 8.43741C9.15998 8.23741 8.43998 7.71741 8.27998 7.87741ZM15.72 7.87741C16.8 9.19741 19.4 10.3974 21.12 10.3974C21.36 10.3974 21.4 11.2774 21.12 11.2774C19.16 11.2774 16.32 9.95741 15.04 8.43741C14.84 8.23741 15.56 7.71741 15.72 7.87741Z"
			fill="#917524"
		/>
		<path
			d="M15.4401 18.5177C13.2801 17.5177 10.7201 17.5177 8.56007 18.5177C8.04007 18.7577 8.68007 20.1977 9.24007 19.9177C10.6801 19.2377 12.8001 18.9977 14.8001 19.9177C15.3201 20.1577 16.0001 18.7977 15.4401 18.5177Z"
			fill="#664E27"
		/>
	</svg>
);

export const Feeling8 = (props) => (
	<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M12 24.7573C18.6274 24.7573 24 19.3847 24 12.7573C24 6.12985 18.6274 0.757263 12 0.757263C5.37258 0.757263 0 6.12985 0 12.7573C0 19.3847 5.37258 24.7573 12 24.7573Z"
			fill="#EF5350"
		/>
		<path
			d="M15.6 19.8376C13.28 17.9176 10.72 17.9176 8.40003 19.8376C8.12003 20.0776 7.88003 19.6776 8.08003 19.3176C8.80003 17.9576 10.2 16.7176 12 16.7176C13.8 16.7176 15.24 17.9576 15.92 19.3176C16.12 19.6376 15.88 20.0376 15.6 19.8376Z"
			fill="#302424"
		/>
		<path
			d="M3.28003 9.91733C2.68003 11.7973 3.52003 13.9173 5.40003 14.7573C7.24003 15.6373 9.40003 14.9573 10.48 13.2773L7.72003 10.1973L3.28003 9.91733Z"
			fill="white"
		/>
		<path
			d="M4.87993 10.2775C4.31993 11.4375 4.83993 12.8375 5.99993 13.3575C7.15993 13.9175 8.55994 13.3975 9.07994 12.2375C9.47994 11.4775 5.23993 9.51747 4.87993 10.2775Z"
			fill="#302424"
		/>
		<path
			d="M3.27991 9.91689C3.91991 9.51689 4.67991 9.31689 5.43991 9.31689C6.19991 9.31689 6.95991 9.51689 7.67991 9.83689C8.35991 10.1569 8.99991 10.6369 9.51991 11.1969C9.99991 11.7969 10.3999 12.4769 10.4799 13.2369C9.95991 12.7169 9.43991 12.2769 8.87991 11.8769C8.31991 11.4769 7.75991 11.1569 7.19991 10.9169C6.59991 10.6369 5.99991 10.4369 5.35991 10.2369C4.63991 10.1169 3.99991 9.99689 3.27991 9.91689Z"
			fill="#302424"
		/>
		<path
			d="M20.72 9.91733C21.32 11.7973 20.48 13.9173 18.6 14.7573C16.76 15.6373 14.6 14.9573 13.52 13.2773L16.28 10.1973L20.72 9.91733Z"
			fill="white"
		/>
		<path
			d="M19.12 10.2775C19.68 11.4375 19.16 12.8375 18 13.3575C16.84 13.9175 15.44 13.3975 14.92 12.2375C14.52 11.4775 18.76 9.51747 19.12 10.2775Z"
			fill="#302424"
		/>
		<path
			d="M20.72 9.91689C20.08 9.51689 19.32 9.31689 18.56 9.31689C17.8 9.31689 17.04 9.51689 16.32 9.83689C15.64 10.1569 15 10.6369 14.48 11.1969C14 11.7969 13.6 12.4769 13.52 13.2369C14.04 12.7169 14.56 12.2769 15.12 11.8769C15.68 11.4769 16.24 11.1569 16.8 10.9169C17.4 10.6369 18 10.4369 18.64 10.2369C19.36 10.1169 20 9.99689 20.72 9.91689Z"
			fill="#302424"
		/>
	</svg>
);

export const Rocket = (props) => (
	<svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x="1" y="1" width="44" height="44" rx="8" fill="white" stroke="#D7DAE0" />
		<path
			d="M27.2144 25.8664C27.3297 26.3558 27.3906 26.8661 27.3906 27.3906C27.3906 31.0495 24.4245 34.0156 20.7656 34.0156V28.716M27.2144 25.8664C31.3374 22.8537 34.0156 17.9817 34.0156 12.4844C28.5185 12.4846 23.6469 15.1629 20.6345 19.2858M27.2144 25.8664C25.3279 27.245 23.1389 28.2342 20.7656 28.716M20.6345 19.2858C20.1448 19.1704 19.6342 19.1094 19.1094 19.1094C15.4505 19.1094 12.4844 22.0755 12.4844 25.7344H17.7852M20.6345 19.2858C19.2561 21.1723 18.2669 23.3612 17.7852 25.7344M20.7656 28.716C20.6514 28.7392 20.5368 28.7612 20.4218 28.782C19.4204 27.988 18.513 27.0806 17.719 26.0792C17.7399 25.9638 17.7619 25.8489 17.7852 25.7344M15.3131 28.3742C14.0988 29.28 13.3125 30.7279 13.3125 32.3594C13.3125 32.6209 13.3327 32.8777 13.3716 33.1284C13.6223 33.1673 13.8791 33.1875 14.1406 33.1875C15.7721 33.1875 17.22 32.4012 18.1258 31.1868M28.2187 19.9375C28.2187 20.8522 27.4772 21.5938 26.5625 21.5938C25.6478 21.5938 24.9062 20.8522 24.9062 19.9375C24.9062 19.0228 25.6478 18.2813 26.5625 18.2813C27.4772 18.2813 28.2187 19.0228 28.2187 19.9375Z"
			stroke="#6E7889"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const Key = (props) => (
	<svg width="45" height="46" viewBox="0 0 45 46" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x="0.5" y="1" width="44" height="44" rx="8" fill="white" stroke="#D7DAE0" />
		<path
			d="M26.3906 15.8066C28.2201 15.8066 29.7031 17.2897 29.7031 19.1191M33.0156 19.1191C33.0156 22.778 30.0495 25.7441 26.3906 25.7441C26.0033 25.7441 25.6238 25.7109 25.2548 25.6471C24.6331 25.5397 23.9747 25.6757 23.5286 26.1218L20.5938 29.0566H18.1094V31.541H15.625V34.0254H11.4844V30.9138C11.4844 30.2549 11.7461 29.623 12.212 29.1571L19.388 21.9811C19.8341 21.535 19.97 20.8767 19.8626 20.255C19.7989 19.8859 19.7656 19.5064 19.7656 19.1191C19.7656 15.4603 22.7317 12.4941 26.3906 12.4941C30.0495 12.4941 33.0156 15.4603 33.0156 19.1191Z"
			stroke="#6E7889"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const PaymentCard = (props) => (
	<svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x="1" y="1" width="44" height="44" rx="8" fill="white" stroke="#D7DAE0" />
		<path
			d="M12.4844 19.1094H34.0156M12.4844 19.9375H34.0156M15.7969 25.7344H22.4219M15.7969 28.2188H19.1094M14.9688 31.5312H31.5312C32.9033 31.5312 34.0156 30.419 34.0156 29.0469V17.4531C34.0156 16.081 32.9033 14.9688 31.5312 14.9688H14.9688C13.5967 14.9688 12.4844 16.081 12.4844 17.4531V29.0469C12.4844 30.419 13.5967 31.5312 14.9688 31.5312Z"
			stroke="#6E7889"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const BriefCase = (props) => (
	<svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x="1" y="1" width="44" height="44" rx="8" fill="white" stroke="#D7DAE0" />
		<path
			d="M32.3594 25.6258V30.3186C32.3594 31.527 31.4905 32.5666 30.2925 32.7257C27.9885 33.0316 25.6377 33.1895 23.25 33.1895C20.8623 33.1895 18.5115 33.0316 16.2075 32.7257C15.0095 32.5666 14.1406 31.527 14.1406 30.3186V25.6258M32.3594 25.6258C32.8805 25.1816 33.1875 24.5095 33.1875 23.7918V19.6145C33.1875 18.4209 32.3396 17.3897 31.1592 17.2131C29.9166 17.0272 28.6599 16.8844 27.3906 16.7863M32.3594 25.6258C32.1456 25.8081 31.8958 25.9519 31.6164 26.0448C28.9865 26.9192 26.1735 27.3926 23.25 27.3926C20.3265 27.3926 17.5135 26.9192 14.8836 26.0448C14.6042 25.9519 14.3544 25.808 14.1406 25.6258M14.1406 25.6258C13.6195 25.1816 13.3125 24.5094 13.3125 23.7917V19.6145C13.3125 18.4209 14.1604 17.3897 15.3408 17.2131C16.5834 17.0272 17.8401 16.8844 19.1094 16.7863M27.3906 16.7863V15.7988C27.3906 14.4267 26.2783 13.3145 24.9062 13.3145H21.5937C20.2217 13.3145 19.1094 14.4267 19.1094 15.7988V16.7863M27.3906 16.7863C26.0243 16.6807 24.6434 16.627 23.25 16.627C21.8566 16.627 20.4757 16.6807 19.1094 16.7863M23.25 24.0801H23.2583V24.0884H23.25V24.0801Z"
			stroke="#6E7889"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const Settings = (props) => (
	<svg width="45" height="46" viewBox="0 0 45 46" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x="0.5" y="1" width="44" height="44" rx="8" fill="white" stroke="#D7DAE0" />
		<path
			d="M20.42 14.3544C20.5198 13.7554 21.0381 13.3164 21.6453 13.3164H22.8532C23.4605 13.3164 23.9787 13.7554 24.0785 14.3544L24.243 15.3413C24.3211 15.8098 24.6666 16.1855 25.1052 16.3676C25.544 16.5498 26.0479 16.5254 26.4346 16.2493L27.249 15.6675C27.7431 15.3146 28.4199 15.3706 28.8493 15.8L29.7035 16.6541C30.1328 17.0835 30.1888 17.7604 29.8359 18.2545L29.254 19.0692C28.9779 19.4557 28.9535 19.9594 29.1357 20.3981C29.3177 20.8366 29.6933 21.1821 30.1617 21.2601L31.1488 21.4247C31.7478 21.5245 32.1868 22.0427 32.1868 22.6499V23.8579C32.1868 24.4651 31.7478 24.9833 31.1488 25.0832L30.1619 25.2476C29.6934 25.3257 29.3177 25.6712 29.1356 26.1098C28.9534 26.5487 28.9778 27.0525 29.2539 27.4391L29.8355 28.2534C30.1885 28.7475 30.1325 29.4244 29.7031 29.8538L28.8489 30.7079C28.4196 31.1373 27.7427 31.1933 27.2486 30.8403L26.4341 30.2586C26.0476 29.9825 25.5438 29.9582 25.1051 30.1403C24.6665 30.3224 24.3211 30.698 24.243 31.1664L24.0785 32.1534C23.9787 32.7524 23.4605 33.1914 22.8532 33.1914H21.6453C21.0381 33.1914 20.5198 32.7524 20.42 32.1534L20.2555 31.1665C20.1775 30.698 19.8319 30.3224 19.3933 30.1402C18.9545 29.9581 18.4507 29.9824 18.064 30.2586L17.2496 30.8403C16.7555 31.1933 16.0786 31.1372 15.6492 30.7079L14.7951 29.8537C14.3657 29.4244 14.3097 28.7475 14.6626 28.2534L15.2446 27.4387C15.5207 27.0521 15.545 26.5484 15.3629 26.1097C15.1808 25.6712 14.8052 25.3257 14.3368 25.2477L13.3497 25.0832C12.7508 24.9833 12.3118 24.4651 12.3118 23.8579V22.6499C12.3118 22.0427 12.7508 21.5245 13.3497 21.4247L14.3367 21.2602C14.8051 21.1821 15.1808 20.8366 15.3629 20.3979C15.5451 19.9591 15.5208 19.4552 15.2446 19.0686L14.6631 18.2544C14.3101 17.7603 14.3661 17.0834 14.7955 16.6541L15.6496 15.7999C16.079 15.3705 16.7559 15.3145 17.25 15.6675L18.0644 16.2492C18.451 16.5253 18.9547 16.5497 19.3935 16.3675C19.832 16.1854 20.1774 15.8098 20.2555 15.3414L20.42 14.3544Z"
			stroke="#6E7889"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M25.5625 23.2539C25.5625 25.0834 24.0795 26.5664 22.25 26.5664C20.4206 26.5664 18.9375 25.0834 18.9375 23.2539C18.9375 21.4245 20.4206 19.9414 22.25 19.9414C24.0795 19.9414 25.5625 21.4245 25.5625 23.2539Z"
			stroke="#6E7889"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const People = (props) => (
	<svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x="1" y="1" width="44" height="44" rx="8" fill="white" stroke="#D7DAE0" />
		<path
			d="M29.875 30.6769C30.1483 30.6994 30.4247 30.7109 30.7038 30.7109C31.8613 30.7109 32.9726 30.513 34.0057 30.1492C34.0127 30.0613 34.0163 29.9725 34.0163 29.8828C34.0163 28.0534 32.5332 26.5703 30.7038 26.5703C30.0108 26.5703 29.3675 26.7831 28.8357 27.1469M29.875 30.6769C29.875 30.6882 29.875 30.6996 29.875 30.7109C29.875 30.9594 29.8614 31.2046 29.8347 31.4459C27.895 32.5589 25.6468 33.1953 23.25 33.1953C20.8533 33.1953 18.6051 32.5589 16.6654 31.4459C16.6387 31.2046 16.625 30.9594 16.625 30.7109C16.625 30.6996 16.6251 30.6883 16.6251 30.677M29.875 30.6769C29.8684 29.3778 29.488 28.1671 28.8357 27.1469M28.8357 27.1469C27.6588 25.3062 25.5969 24.0859 23.25 24.0859C20.9035 24.0859 18.8418 25.3059 17.6648 27.1463M17.6648 27.1463C17.1332 26.7829 16.4903 26.5703 15.7977 26.5703C13.9683 26.5703 12.4852 28.0534 12.4852 29.8828C12.4852 29.9725 12.4888 30.0613 12.4958 30.1492C13.5289 30.513 14.6402 30.7109 15.7977 30.7109C16.0764 30.7109 16.3523 30.6995 16.6251 30.677M17.6648 27.1463C17.0123 28.1666 16.6317 29.3775 16.6251 30.677M26.5625 17.4609C26.5625 19.2904 25.0795 20.7734 23.25 20.7734C21.4206 20.7734 19.9375 19.2904 19.9375 17.4609C19.9375 15.6315 21.4206 14.1484 23.25 14.1484C25.0795 14.1484 26.5625 15.6315 26.5625 17.4609ZM33.1875 20.7734C33.1875 22.1455 32.0753 23.2578 30.7032 23.2578C29.3311 23.2578 28.2188 22.1455 28.2188 20.7734C28.2188 19.4014 29.3311 18.2891 30.7032 18.2891C32.0753 18.2891 33.1875 19.4014 33.1875 20.7734ZM18.2813 20.7734C18.2813 22.1455 17.169 23.2578 15.7969 23.2578C14.4248 23.2578 13.3125 22.1455 13.3125 20.7734C13.3125 19.4014 14.4248 18.2891 15.7969 18.2891C17.169 18.2891 18.2813 19.4014 18.2813 20.7734Z"
			stroke="#6E7889"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const TailoredJob = (props) => (
	<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width="48" height="48" rx="12" fill="#E6F3FF" />
		<g clipPath="url(#clip0_929_2228)">
			<path
				d="M19.7344 32.901L20.2083 27.2135H22.5781V23.8958C22.5781 22.6388 22.0788 21.4333 21.1899 20.5444C20.3011 19.6556 19.0955 19.1562 17.8385 19.1562C16.5815 19.1562 15.376 19.6556 14.4871 20.5444C13.5983 21.4333 13.0989 22.6388 13.0989 23.8958V27.2135H15.4687L15.9427 32.901H19.7344Z"
				fill="#B9DDFE"
			/>
			<path
				d="M17.8385 19.1562C16.5815 19.1562 15.376 19.6556 14.4871 20.5444C13.5983 21.4333 13.0989 22.6388 13.0989 23.8958V26.2656C13.0989 25.0086 13.5983 23.8031 14.4871 22.9142C15.376 22.0254 16.5815 21.526 17.8385 21.526C19.0955 21.526 20.3011 22.0254 21.1899 22.9142C22.0788 23.8031 22.5781 25.0086 22.5781 26.2656V23.8958C22.5781 22.6388 22.0788 21.4333 21.1899 20.5444C20.3011 19.6556 19.0955 19.1562 17.8385 19.1562Z"
				fill="white"
			/>
			<path
				d="M14.5208 14.4167C14.5208 14.8524 14.6066 15.2838 14.7734 15.6863C14.9401 16.0889 15.1845 16.4546 15.4925 16.7627C15.8006 17.0708 16.1664 17.3151 16.5689 17.4819C16.9714 17.6486 17.4028 17.7344 17.8385 17.7344C18.2742 17.7344 18.7056 17.6486 19.1082 17.4819C19.5107 17.3151 19.8764 17.0708 20.1845 16.7627C20.4926 16.4546 20.737 16.0889 20.9037 15.6863C21.0704 15.2838 21.1562 14.8524 21.1562 14.4167C21.1562 13.5368 20.8067 12.6929 20.1845 12.0707C19.5623 11.4485 18.7184 11.099 17.8385 11.099C16.9586 11.099 16.1147 11.4485 15.4925 12.0707C14.8704 12.6929 14.5208 13.5368 14.5208 14.4167Z"
				fill="#B9DDFE"
			/>
			<path
				d="M17.8385 12.9948C18.5507 12.9965 19.2433 13.2281 19.8132 13.655C20.3831 14.082 20.8 14.6816 21.0017 15.3646C21.0997 15.058 21.1517 14.7386 21.1562 14.4167C21.1562 13.5368 20.8067 12.6929 20.1845 12.0707C19.5623 11.4485 18.7184 11.099 17.8385 11.099C16.9586 11.099 16.1147 11.4485 15.4925 12.0707C14.8704 12.6929 14.5208 13.5368 14.5208 14.4167C14.5253 14.7386 14.5774 15.058 14.6753 15.3646C14.877 14.6816 15.2939 14.082 15.8638 13.655C16.4338 13.2281 17.1264 12.9965 17.8385 12.9948Z"
				fill="white"
			/>
			<path
				d="M14.5208 14.4167C14.5208 14.8524 14.6066 15.2838 14.7734 15.6863C14.9401 16.0889 15.1845 16.4546 15.4925 16.7627C15.8006 17.0708 16.1664 17.3151 16.5689 17.4819C16.9714 17.6486 17.4028 17.7344 17.8385 17.7344C18.2742 17.7344 18.7056 17.6486 19.1082 17.4819C19.5107 17.3151 19.8764 17.0708 20.1845 16.7627C20.4926 16.4546 20.737 16.0889 20.9037 15.6863C21.0704 15.2838 21.1562 14.8524 21.1562 14.4167C21.1562 13.5368 20.8067 12.6929 20.1845 12.0707C19.5623 11.4485 18.7184 11.099 17.8385 11.099C16.9586 11.099 16.1147 11.4485 15.4925 12.0707C14.8704 12.6929 14.5208 13.5368 14.5208 14.4167Z"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M24.474 24.3698H33.9531C33.9531 24.3698 34.9011 24.3698 34.9011 25.3177V31.9531C34.9011 31.9531 34.9011 32.901 33.9531 32.901H24.474C24.474 32.901 23.5261 32.901 23.5261 31.9531V25.3177C23.5261 25.3177 23.5261 24.3698 24.474 24.3698Z"
				fill="#F0F7FF"
			/>
			<path
				d="M24.474 24.3698C24.2226 24.3698 23.9815 24.4696 23.8037 24.6474C23.6259 24.8252 23.5261 25.0663 23.5261 25.3177V31.9531C23.5261 32.2045 23.6259 32.4456 23.8037 32.6234C23.9815 32.8011 24.2226 32.901 24.474 32.901H24.7129L33.2441 24.3698H24.474Z"
				fill="#F0F7FF"
			/>
			<path
				d="M24.474 24.3698H33.9531C33.9531 24.3698 34.9011 24.3698 34.9011 25.3177V31.9531C34.9011 31.9531 34.9011 32.901 33.9531 32.901H24.474C24.474 32.901 23.5261 32.901 23.5261 31.9531V25.3177C23.5261 25.3177 23.5261 24.3698 24.474 24.3698Z"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M23.5261 28.1615H34.9011"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M29.2136 28.1615V29.5834"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M30.0496 22.474C30.2256 22.4741 30.3981 22.5232 30.5478 22.6158C30.6974 22.7083 30.8184 22.8408 30.897 22.9982L31.5833 24.3698H26.8438L27.53 22.9982C27.6087 22.8408 27.7297 22.7083 27.8793 22.6158C28.029 22.5232 28.2015 22.4741 28.3775 22.474H30.0496Z"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.5208 14.4167C14.5208 14.8524 14.6066 15.2838 14.7734 15.6863C14.9401 16.0889 15.1845 16.4546 15.4925 16.7627C15.8006 17.0708 16.1664 17.3151 16.5689 17.4819C16.9714 17.6486 17.4028 17.7344 17.8385 17.7344C18.2742 17.7344 18.7056 17.6486 19.1082 17.4819C19.5107 17.3151 19.8764 17.0708 20.1845 16.7627C20.4926 16.4546 20.737 16.0889 20.9037 15.6863C21.0704 15.2838 21.1562 14.8524 21.1562 14.4167C21.1562 13.5368 20.8067 12.6929 20.1845 12.0707C19.5623 11.4485 18.7184 11.099 17.8385 11.099C16.9586 11.099 16.1147 11.4485 15.4925 12.0707C14.8704 12.6929 14.5208 13.5368 14.5208 14.4167Z"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22.3601 22.4739C22.0205 21.3935 21.3053 20.4703 20.344 19.8717C19.3826 19.273 18.2387 19.0383 17.1193 19.2102C15.9999 19.382 14.979 19.9491 14.2415 20.8086C13.504 21.6681 13.0987 22.7633 13.0989 23.8958V27.2135H15.4687L15.9427 32.901H19.7344L20.2083 27.2135H21.1562"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_929_2228">
				<rect width="24" height="24" fill="white" transform="translate(12 10)" />
			</clipPath>
		</defs>
	</svg>
);

export const OneClick = (props) => (
	<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width="48" height="48" rx="12" fill="#E6F3FF" />
		<path
			d="M14.1563 27.2812L14.8491 31.7813C14.9163 32.2247 15.1403 32.6293 15.4804 32.9217C15.8204 33.2141 16.254 33.3749 16.7025 33.375H31.2975C31.746 33.3749 32.1796 33.2141 32.5196 32.9217C32.8597 32.6293 33.0837 32.2247 33.1509 31.7813L33.8438 27.2812C34.0924 27.2812 34.3308 27.1825 34.5067 27.0067C34.6825 26.8308 34.7812 26.5924 34.7812 26.3438V20.25C34.7812 19.7527 34.5837 19.2758 34.2321 18.9242C33.8804 18.5725 33.4035 18.375 32.9062 18.375H15.0938C14.5965 18.375 14.1196 18.5725 13.7679 18.9242C13.4163 19.2758 13.2188 19.7527 13.2188 20.25V26.3438C13.2188 26.5924 13.3175 26.8308 13.4933 27.0067C13.6692 27.1825 13.9076 27.2812 14.1563 27.2812Z"
			fill="#B9DDFE"
		/>
		<path
			d="M32.9062 18.375H15.0938C14.5965 18.375 14.1196 18.5725 13.7679 18.9242C13.4163 19.2758 13.2188 19.7527 13.2188 20.25V23.5312C13.2188 23.034 13.4163 22.5571 13.7679 22.2054C14.1196 21.8538 14.5965 21.6563 15.0938 21.6563H32.9062C33.4035 21.6563 33.8804 21.8538 34.2321 22.2054C34.5837 22.5571 34.7812 23.034 34.7812 23.5312V20.25C34.7812 19.7527 34.5837 19.2758 34.2321 18.9242C33.8804 18.5725 33.4035 18.375 32.9062 18.375Z"
			fill="#F0F7FF"
		/>
		<path
			d="M14.1563 27.2813L14.8491 31.7813C14.9163 32.2247 15.1403 32.6293 15.4804 32.9217C15.8204 33.2141 16.254 33.3749 16.7025 33.375H31.2975C31.746 33.3749 32.1796 33.2141 32.5196 32.9217C32.8597 32.6293 33.0837 32.2247 33.1509 31.7813L33.8438 27.2813C34.0924 27.2813 34.3308 27.1825 34.5067 27.0067C34.6825 26.8308 34.7813 26.5924 34.7813 26.3438V20.25C34.7813 19.7527 34.5837 19.2758 34.2321 18.9242C33.8804 18.5725 33.4035 18.375 32.9063 18.375H15.0938C14.5965 18.375 14.1196 18.5725 13.7679 18.9242C13.4163 19.2758 13.2188 19.7527 13.2188 20.25V26.3438C13.2188 26.5924 13.3175 26.8308 13.4933 27.0067C13.6692 27.1825 13.9076 27.2813 14.1563 27.2813Z"
			stroke="#0069CB"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M28.2188 18.375H19.7812V17.4375C19.7812 16.6916 20.0776 15.9762 20.605 15.4488C21.1325 14.9213 21.8478 14.625 22.5938 14.625H25.4063C26.1522 14.625 26.8675 14.9213 27.395 15.4488C27.9224 15.9762 28.2188 16.6916 28.2188 17.4375V18.375Z"
			stroke="#0069CB"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M14.1562 27.2812H22.125"
			stroke="#0069CB"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M25.875 27.2812H33.8438"
			stroke="#0069CB"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M22.125 27.2812C22.125 27.9029 22.3225 28.499 22.6742 28.9385C23.0258 29.3781 23.5027 29.625 24 29.625C24.4973 29.625 24.9742 29.3781 25.3258 28.9385C25.6775 28.499 25.875 27.9029 25.875 27.2812C25.875 26.6596 25.6775 26.0635 25.3258 25.624C24.9742 25.1844 24.4973 24.9375 24 24.9375C23.5027 24.9375 23.0258 25.1844 22.6742 25.624C22.3225 26.0635 22.125 26.6596 22.125 27.2812Z"
			fill="#F0F7FF"
		/>
		<path
			d="M24 27.6834C23.6096 27.6573 23.2367 27.5115 22.932 27.2659C22.6274 27.0204 22.4058 26.6869 22.2975 26.3109C22.1837 26.6218 22.1253 26.9502 22.125 27.2812C22.0699 27.8393 22.2351 28.3968 22.5854 28.8347C22.9358 29.2726 23.4434 29.5562 24 29.625C24.5565 29.5562 25.0642 29.2726 25.4145 28.8347C25.7648 28.3968 25.9301 27.8393 25.875 27.2812C25.8746 26.9502 25.8163 26.6218 25.7025 26.3109C25.5941 26.6869 25.3725 27.0204 25.0679 27.2659C24.7633 27.5115 24.3904 27.6573 24 27.6834Z"
			fill="#B9DDFE"
		/>
		<path
			d="M22.125 27.2813C22.125 27.9029 22.3225 28.499 22.6742 28.9385C23.0258 29.3781 23.5027 29.625 24 29.625C24.4973 29.625 24.9742 29.3781 25.3258 28.9385C25.6775 28.499 25.875 27.9029 25.875 27.2813C25.875 26.6596 25.6775 26.0635 25.3258 25.624C24.9742 25.1844 24.4973 24.9375 24 24.9375C23.5027 24.9375 23.0258 25.1844 22.6742 25.624C22.3225 26.0635 22.125 26.6596 22.125 27.2813Z"
			stroke="#0069CB"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const PersonalizedFeedback = (props) => (
	<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width="48" height="48" rx="12" fill="#E6F3FF" />
		<g clipPath="url(#clip0_929_2242)">
			<path
				d="M14.0469 13.097H33.9531C33.9531 13.097 34.901 13.097 34.901 14.045V33.9512C34.901 33.9512 34.901 34.8991 33.9531 34.8991H14.0469C14.0469 34.8991 13.0989 34.8991 13.0989 33.9512V14.045C13.0989 14.045 13.0989 13.097 14.0469 13.097Z"
				fill="#B9DDFE"
			/>
			<path
				d="M24 13.099H14.0469C13.7955 13.099 13.5543 13.1989 13.3766 13.3766C13.1988 13.5544 13.0989 13.7955 13.0989 14.0469V33.9532C13.0989 34.2046 13.1988 34.4457 13.3766 34.6234C13.5543 34.8012 13.7955 34.9011 14.0469 34.9011H24V13.099Z"
				fill="white"
			/>
			<path
				d="M14.0469 13.097H33.9531C33.9531 13.097 34.901 13.097 34.901 14.045V33.9512C34.901 33.9512 34.901 34.8991 33.9531 34.8991H14.0469C14.0469 34.8991 13.0989 34.8991 13.0989 33.9512V14.045C13.0989 14.045 13.0989 13.097 14.0469 13.097Z"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.7864 18.7845H22.5781"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.9427 22.5762H22.5781"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.9427 26.3679H32.0573"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.9427 30.1595H27.3177"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M25.8958 16.8887H31.5833C31.5833 16.8887 32.0573 16.8887 32.0573 17.3626V23.0501C32.0573 23.0501 32.0573 23.5241 31.5833 23.5241H25.8958C25.8958 23.5241 25.4219 23.5241 25.4219 23.0501V17.3626C25.4219 17.3626 25.4219 16.8887 25.8958 16.8887Z"
				fill="#F0F7FF"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_929_2242">
				<rect width="24" height="24" fill="white" transform="translate(12 12)" />
			</clipPath>
		</defs>
	</svg>
);

export const AIPowered = (props) => (
	<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width="48" height="48" rx="12" fill="#E6F3FF" />
		<path
			d="M30.8648 16.8907H15.6981C15.1953 16.8907 14.7131 16.6909 14.3576 16.3354C14.0021 15.9799 13.8023 15.4976 13.8023 14.9948C13.8023 14.492 14.0021 14.0098 14.3576 13.6543C14.7131 13.2987 15.1953 13.099 15.6981 13.099H30.8648V16.8907Z"
			fill="white"
		/>
		<path
			d="M31.8127 17.8385V33.9531C31.8127 34.2045 31.7129 34.4456 31.5351 34.6234C31.3573 34.8011 31.1162 34.901 30.8648 34.901H15.6981C15.1953 34.901 14.7131 34.7013 14.3576 34.3457C14.0021 33.9902 13.8023 33.508 13.8023 33.0052V14.9948C13.8023 15.4976 14.0021 15.9798 14.3576 16.3353C14.7131 16.6908 15.1953 16.8906 15.6981 16.8906H30.8648C31.1162 16.8906 31.3573 16.9905 31.5351 17.1682C31.7129 17.346 31.8127 17.5871 31.8127 17.8385Z"
			fill="#F0F7FF"
		/>
		<path
			d="M17.0413 33.0052V16.8906H15.6944C15.1916 16.8906 14.7093 16.6908 14.3538 16.3353C13.9983 15.9798 13.7985 15.4976 13.7985 14.9948V33.0052C13.7985 33.508 13.9983 33.9902 14.3538 34.3457C14.7093 34.7013 15.1916 34.901 15.6944 34.901H18.9372C18.4344 34.901 17.9522 34.7013 17.5966 34.3457C17.2411 33.9902 17.0413 33.508 17.0413 33.0052Z"
			fill="#B9DDFE"
		/>
		<path
			d="M23.836 34.901H15.7019C15.1991 34.901 14.7169 34.7013 14.3614 34.3457C14.0058 33.9902 13.8061 33.508 13.8061 33.0052V14.9948"
			stroke="#0069CB"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M31.8165 13.099H15.7019C15.1991 13.099 14.7169 13.2987 14.3614 13.6543C14.0058 14.0098 13.8061 14.492 13.8061 14.9948C13.8061 15.4976 14.0058 15.9799 14.3614 16.3354C14.7169 16.6909 15.1991 16.8907 15.7019 16.8907H30.8686C30.9931 16.8907 31.1164 16.9152 31.2314 16.9628C31.3464 17.0105 31.4509 17.0803 31.5389 17.1683C31.6269 17.2563 31.6967 17.3608 31.7444 17.4758C31.792 17.5908 31.8165 17.7141 31.8165 17.8386V24.0247"
			stroke="#0069CB"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M15.7019 14.9948H30.8686"
			stroke="#0069CB"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M27.5784 33.0611C28.4275 33.0611 29.2575 32.8093 29.9635 32.3376C30.6695 31.8658 31.2198 31.1953 31.5447 30.4109C31.8696 29.6264 31.9547 28.7632 31.789 27.9304C31.6234 27.0976 31.2145 26.3327 30.6141 25.7323C30.0137 25.1319 29.2487 24.723 28.4159 24.5573C27.5831 24.3917 26.7199 24.4767 25.9355 24.8016C25.151 25.1266 24.4805 25.6768 24.0088 26.3828C23.5371 27.0888 23.2853 27.9189 23.2853 28.768C23.2853 29.9066 23.7376 30.9985 24.5427 31.8037C25.3478 32.6088 26.4398 33.0611 27.5784 33.0611Z"
			fill="white"
			stroke="#0069CB"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M33.7124 34.901L30.6354 31.8231"
			stroke="#0069CB"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M27.5784 33.0611C28.4275 33.0611 29.2575 32.8093 29.9635 32.3376C30.6695 31.8658 31.2198 31.1953 31.5447 30.4109C31.8696 29.6264 31.9547 28.7632 31.789 27.9304C31.6234 27.0976 31.2145 26.3327 30.6141 25.7323C30.0137 25.1319 29.2487 24.723 28.4159 24.5573C27.5831 24.3917 26.7199 24.4767 25.9355 24.8016C25.151 25.1266 24.4805 25.6768 24.0088 26.3828C23.5371 27.0888 23.2853 27.9189 23.2853 28.768C23.2853 29.9066 23.7376 30.9985 24.5427 31.8037C25.3478 32.6088 26.4398 33.0611 27.5784 33.0611Z"
			fill="#B9DDFE"
		/>
		<path
			d="M27.5784 24.474C26.7278 24.4739 25.8964 24.7265 25.1896 25.1998C24.4829 25.6731 23.9327 26.3457 23.6089 27.1322C23.2851 27.9188 23.2023 28.7838 23.371 29.6175C23.5397 30.4511 23.9523 31.2159 24.5564 31.8147L30.6231 25.748C30.2252 25.3446 29.7512 25.0243 29.2285 24.8055C28.7059 24.5868 28.145 24.4741 27.5784 24.474Z"
			fill="white"
		/>
		<path
			d="M27.5784 33.0611C28.4275 33.0611 29.2575 32.8093 29.9635 32.3376C30.6695 31.8658 31.2198 31.1953 31.5447 30.4109C31.8696 29.6264 31.9547 28.7632 31.789 27.9304C31.6234 27.0976 31.2145 26.3327 30.6141 25.7323C30.0137 25.1319 29.2487 24.723 28.4159 24.5573C27.5831 24.3917 26.7199 24.4767 25.9355 24.8016C25.151 25.1266 24.4805 25.6768 24.0088 26.3828C23.5371 27.0888 23.2853 27.9189 23.2853 28.768C23.2853 29.9066 23.7376 30.9985 24.5427 31.8037C25.3478 32.6088 26.4398 33.0611 27.5784 33.0611Z"
			stroke="#0069CB"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M33.7124 34.9011L30.6354 31.8213"
			stroke="#0069CB"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const StreamlinedProcess = (props) => (
	<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width="48" height="48" rx="12" fill="#E6F3FF" />
		<g clipPath="url(#clip0_929_2258)">
			<path
				d="M14.9948 13.098H33.0052C33.0052 13.098 34.901 13.098 34.901 14.9939V33.0043C34.901 33.0043 34.901 34.9001 33.0052 34.9001H14.9948C14.9948 34.9001 13.099 34.9001 13.099 33.0043V14.9939C13.099 14.9939 13.099 13.098 14.9948 13.098Z"
				fill="#B9DDFE"
			/>
			<path
				d="M24 13.099H14.9948C14.492 13.099 14.0098 13.2987 13.6542 13.6543C13.2987 14.0098 13.099 14.492 13.099 14.9948V33.0052C13.099 33.5081 13.2987 33.9903 13.6542 34.3458C14.0098 34.7013 14.492 34.9011 14.9948 34.9011H24V13.099Z"
				fill="white"
			/>
			<path
				d="M14.9948 13.098H33.0052C33.0052 13.098 34.901 13.098 34.901 14.9939V33.0043C34.901 33.0043 34.901 34.9001 33.0052 34.9001H14.9948C14.9948 34.9001 13.099 34.9001 13.099 33.0043V14.9939C13.099 14.9939 13.099 13.098 14.9948 13.098Z"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.3646 19.7334L18.7865 21.1553L22.5781 17.3636"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.3646 29.2126L18.7865 30.6344L22.5781 26.8428"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M25.4219 20.6814H31.1094"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M25.4219 29.2126H31.1094"
				stroke="#0069CB"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_929_2258">
				<rect width="24" height="24" fill="white" transform="translate(12 12)" />
			</clipPath>
		</defs>
	</svg>
);

export const RealTime = (props) => (
	<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width="48" height="48" rx="12" fill="#E6F3FF" />
		<path
			d="M32.25 20.511C33.1341 20.7955 33.75 21.6392 33.75 22.6082V26.8938C33.75 28.0304 32.9026 28.9943 31.7697 29.0867C31.4308 29.1144 31.0909 29.1386 30.75 29.1592V32.25L27.75 29.25C26.3963 29.25 25.0556 29.1948 23.7302 29.0866C23.4319 29.0623 23.1534 28.9775 22.9049 28.8451M32.25 20.511C32.0986 20.4623 31.9393 20.43 31.7739 20.4163C30.4472 20.3062 29.1051 20.25 27.75 20.25C26.3948 20.25 25.0528 20.3062 23.7261 20.4163C22.595 20.5101 21.75 21.4732 21.75 22.6082V26.8937C21.75 27.731 22.2099 28.4746 22.9049 28.8451M32.25 20.511V18.6373C32.25 17.0159 31.0983 15.6106 29.4903 15.4019C27.4478 15.1368 25.365 15 23.2503 15C21.1353 15 19.0523 15.1368 17.0096 15.402C15.4017 15.6107 14.25 17.016 14.25 18.6374V24.8626C14.25 26.484 15.4017 27.8893 17.0096 28.098C17.5866 28.1729 18.1668 28.2376 18.75 28.2918V33L22.9049 28.8451"
			stroke="#0069CB"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const DataDriven = (props) => (
	<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width="48" height="48" rx="12" fill="#E6F3FF" />
		<g clipPath="url(#clip0_929_2272)">
			<path
				d="M16.2727 30.9546H14.3409C14.2788 30.9533 14.217 30.9643 14.159 30.9869C14.1011 31.0095 14.0482 31.0433 14.0034 31.0863C13.9585 31.1294 13.9226 31.1809 13.8977 31.2378C13.8727 31.2947 13.8592 31.356 13.858 31.4182V33.3114C13.8592 33.2492 13.8727 33.1879 13.8977 33.131C13.9226 33.074 13.9585 33.0226 14.0034 32.9795C14.0482 32.9365 14.1011 32.9027 14.159 32.8801C14.217 32.8574 14.2788 32.8465 14.3409 32.8478H16.2727C16.3349 32.8465 16.3967 32.8574 16.4546 32.8801C16.5125 32.9027 16.5654 32.9365 16.6103 32.9795C16.6551 33.0226 16.691 33.074 16.716 33.131C16.7409 33.1879 16.7544 33.2492 16.7557 33.3114V31.4182C16.7544 31.356 16.7409 31.2947 16.716 31.2378C16.691 31.1809 16.6551 31.1294 16.6103 31.0863C16.5654 31.0433 16.5125 31.0095 16.4546 30.9869C16.3967 30.9643 16.3349 30.9533 16.2727 30.9546Z"
				fill="#B9DDFE"
			/>
			<path
				d="M22.0682 26.3182H20.1364C20.0742 26.3169 20.0124 26.3279 19.9545 26.3505C19.8966 26.3731 19.8437 26.4069 19.7988 26.45C19.754 26.493 19.7181 26.5445 19.6931 26.6014C19.6682 26.6584 19.6547 26.7197 19.6534 26.7819V28.675C19.6547 28.6129 19.6682 28.5516 19.6931 28.4946C19.7181 28.4377 19.754 28.3862 19.7988 28.3432C19.8437 28.3001 19.8966 28.2663 19.9545 28.2437C20.0124 28.2211 20.0742 28.2101 20.1364 28.2114H22.0682C22.1303 28.2101 22.1921 28.2211 22.2501 28.2437C22.308 28.2663 22.3609 28.3001 22.4057 28.3432C22.4506 28.3862 22.4865 28.4377 22.5114 28.4946C22.5364 28.5516 22.5499 28.6129 22.5511 28.675V26.7819C22.5499 26.7197 22.5364 26.6584 22.5114 26.6014C22.4865 26.5445 22.4506 26.493 22.4057 26.45C22.3609 26.4069 22.308 26.3731 22.2501 26.3505C22.1921 26.3279 22.1303 26.3169 22.0682 26.3182Z"
				fill="#B9DDFE"
			/>
			<path
				d="M27.8636 29.1H25.9318C25.8697 29.0987 25.8079 29.1096 25.75 29.1323C25.692 29.1549 25.6391 29.1887 25.5943 29.2317C25.5494 29.2748 25.5135 29.3262 25.4886 29.3832C25.4636 29.4401 25.4501 29.5014 25.4489 29.5636V31.4568C25.4501 31.3946 25.4636 31.3333 25.4886 31.2764C25.5135 31.2194 25.5494 31.168 25.5943 31.1249C25.6391 31.0818 25.692 31.048 25.75 31.0254C25.8079 31.0028 25.8697 30.9919 25.9318 30.9931H27.8636C27.9258 30.9919 27.9876 31.0028 28.0455 31.0254C28.1034 31.048 28.1563 31.0818 28.2012 31.1249C28.246 31.168 28.2819 31.2194 28.3069 31.2764C28.3318 31.3333 28.3453 31.3946 28.3466 31.4568V29.5636C28.3453 29.5014 28.3318 29.4401 28.3069 29.3832C28.2819 29.3262 28.246 29.2748 28.2012 29.2317C28.1563 29.1887 28.1034 29.1549 28.0455 29.1323C27.9876 29.1096 27.9258 29.0987 27.8636 29.1Z"
				fill="#B9DDFE"
			/>
			<path
				d="M33.6591 21.6819H31.7273C31.6651 21.6806 31.6033 21.6916 31.5454 21.7142C31.4875 21.7368 31.4346 21.7706 31.3897 21.8136C31.3449 21.8567 31.309 21.9082 31.284 21.9651C31.2591 22.022 31.2456 22.0833 31.2443 22.1455V24.0387C31.2456 23.9765 31.2591 23.9152 31.284 23.8583C31.309 23.8013 31.3449 23.7499 31.3897 23.7068C31.4346 23.6638 31.4875 23.63 31.5454 23.6073C31.6033 23.5847 31.6651 23.5738 31.7273 23.575H33.6591C33.7212 23.5738 33.783 23.5847 33.841 23.6073C33.8989 23.63 33.9518 23.6638 33.9966 23.7068C34.0415 23.7499 34.0774 23.8013 34.1023 23.8583C34.1273 23.9152 34.1408 23.9765 34.142 24.0387V22.1455C34.1408 22.0833 34.1273 22.022 34.1023 21.9651C34.0774 21.9082 34.0415 21.8567 33.9966 21.8136C33.9518 21.7706 33.8989 21.7368 33.841 21.7142C33.783 21.6916 33.7212 21.6806 33.6591 21.6819Z"
				fill="#B9DDFE"
			/>
			<path
				d="M16.7557 31.4182C16.7544 31.356 16.7409 31.2947 16.716 31.2378C16.691 31.1809 16.6551 31.1294 16.6103 31.0863C16.5654 31.0433 16.5125 31.0095 16.4546 30.9869C16.3967 30.9643 16.3349 30.9533 16.2727 30.9546H14.3409C14.2788 30.9533 14.217 30.9643 14.159 30.9869C14.1011 31.0095 14.0482 31.0433 14.0034 31.0863C13.9585 31.1294 13.9226 31.1809 13.8977 31.2378C13.8727 31.2947 13.8592 31.356 13.858 31.4182V34.6637H16.7557V31.4182Z"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22.5511 26.7819C22.5499 26.7197 22.5364 26.6584 22.5114 26.6014C22.4865 26.5445 22.4506 26.493 22.4057 26.45C22.3609 26.4069 22.308 26.3731 22.2501 26.3505C22.1921 26.3279 22.1303 26.3169 22.0682 26.3182H20.1364C20.0742 26.3169 20.0124 26.3279 19.9545 26.3505C19.8966 26.3731 19.8437 26.4069 19.7988 26.45C19.754 26.493 19.7181 26.5445 19.6931 26.6014C19.6682 26.6584 19.6547 26.7197 19.6534 26.7819V34.6637H22.5511V26.7819Z"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M28.3466 29.5636C28.3453 29.5014 28.3318 29.4401 28.3069 29.3832C28.2819 29.3262 28.246 29.2748 28.2012 29.2317C28.1563 29.1887 28.1034 29.1549 28.0455 29.1323C27.9876 29.1096 27.9258 29.0987 27.8636 29.1H25.9318C25.8697 29.0987 25.8079 29.1096 25.75 29.1323C25.692 29.1549 25.6391 29.1887 25.5943 29.2317C25.5494 29.2748 25.5135 29.3262 25.4886 29.3832C25.4636 29.4401 25.4501 29.5014 25.4489 29.5636V34.6636H28.3466V29.5636Z"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M34.142 22.1455C34.1408 22.0833 34.1273 22.022 34.1023 21.9651C34.0774 21.9082 34.0415 21.8567 33.9966 21.8136C33.9518 21.7706 33.8989 21.7368 33.841 21.7142C33.783 21.6916 33.7212 21.6806 33.6591 21.6819H31.7273C31.6651 21.6806 31.6033 21.6916 31.5454 21.7142C31.4875 21.7368 31.4346 21.7706 31.3897 21.8136C31.3449 21.8567 31.309 21.9082 31.284 21.9651C31.2591 22.022 31.2456 22.0833 31.2443 22.1455V34.6637H34.142V22.1455Z"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.892 34.6636H35.108"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.1897 20.8367L18.7706 18.3591"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21.8055 17.9824L24.2627 19.3637"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M27.4512 19.1482L31.1738 16.3403"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M32.6932 17.0454C33.1952 17.0555 33.6808 16.8658 34.043 16.518C34.4053 16.1703 34.6146 15.6929 34.625 15.1909C34.625 14.6785 34.4215 14.1871 34.0592 13.8248C33.6969 13.4626 33.2055 13.259 32.6932 13.259C32.1808 13.259 31.6895 13.4626 31.3272 13.8248C30.9649 14.1871 30.7614 14.6785 30.7614 15.1909C30.7718 15.6929 30.9811 16.1703 31.3433 16.518C31.7056 16.8658 32.1911 17.0555 32.6932 17.0454Z"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M25.9318 22.1455C26.4339 22.1556 26.9194 21.9659 27.2817 21.6181C27.6439 21.2704 27.8532 20.793 27.8636 20.2909C27.8636 19.7786 27.6601 19.2872 27.2978 18.9249C26.9355 18.5627 26.4442 18.3591 25.9318 18.3591C25.4195 18.3591 24.9281 18.5627 24.5658 18.9249C24.2035 19.2872 24 19.7786 24 20.2909C24.0104 20.793 24.2197 21.2704 24.582 21.6181C24.9442 21.9659 25.4298 22.1556 25.9318 22.1455Z"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20.1364 18.9C20.6384 18.9101 21.1239 18.7204 21.4862 18.3727C21.8484 18.0249 22.0578 17.5475 22.0682 17.0455C22.0682 16.5331 21.8647 16.0418 21.5024 15.6795C21.1401 15.3172 20.6487 15.1136 20.1364 15.1136C19.624 15.1136 19.1326 15.3172 18.7704 15.6795C18.4081 16.0418 18.2045 16.5331 18.2045 17.0455C18.2149 17.5475 18.4243 18.0249 18.7865 18.3727C19.1488 18.7204 19.6343 18.9101 20.1364 18.9Z"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.8239 24C15.0745 24.0114 15.3249 23.9719 15.5599 23.8839C15.7949 23.7958 16.0095 23.6611 16.191 23.4877C16.3724 23.3144 16.5168 23.1061 16.6155 22.8754C16.7141 22.6447 16.765 22.3963 16.765 22.1454C16.765 21.8945 16.7141 21.6462 16.6155 21.4155C16.5168 21.1847 16.3724 20.9764 16.191 20.8031C16.0095 20.6298 15.7949 20.495 15.5599 20.407C15.3249 20.3189 15.0745 20.2794 14.8239 20.2909C14.5732 20.2794 14.3228 20.3189 14.0878 20.407C13.8529 20.495 13.6382 20.6298 13.4567 20.8031C13.2753 20.9764 13.1309 21.1847 13.0322 21.4155C12.9336 21.6462 12.8827 21.8945 12.8827 22.1454C12.8827 22.3963 12.9336 22.6447 13.0322 22.8754C13.1309 23.1061 13.2753 23.3144 13.4567 23.4877C13.6382 23.6611 13.8529 23.7958 14.0878 23.8839C14.3228 23.9719 14.5732 24.0114 14.8239 24Z"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_929_2272">
				<rect width="24" height="24" fill="white" transform="translate(12 12)" />
			</clipPath>
		</defs>
	</svg>
);

export const Efficiency = (props) => (
	<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width="48" height="48" rx="12" fill="#E6F3FF" />
		<path
			d="M12 24C12 25.5759 12.3104 27.1363 12.9134 28.5922C13.5165 30.0481 14.4004 31.371 15.5147 32.4853C16.629 33.5996 17.9519 34.4835 19.4078 35.0866C20.8637 35.6896 22.4241 36 24 36C25.5759 36 27.1363 35.6896 28.5922 35.0866C30.0481 34.4835 31.371 33.5996 32.4853 32.4853C33.5996 31.371 34.4835 30.0481 35.0866 28.5922C35.6896 27.1363 36 25.5759 36 24C36 20.8174 34.7357 17.7652 32.4853 15.5147C30.2348 13.2643 27.1826 12 24 12C20.8174 12 17.7652 13.2643 15.5147 15.5147C13.2643 17.7652 12 20.8174 12 24Z"
			fill="#F0F7FF"
		/>
		<path
			d="M15.5147 32.4863C13.2641 30.2358 11.9998 27.1834 11.9998 24.0006C11.9998 20.8179 13.2641 17.7654 15.5147 15.5149C17.7652 13.2643 20.8176 12 24.0004 12C27.1831 12 30.2355 13.2643 32.4861 15.5149L15.5147 32.4863Z"
			fill="#B9DDFE"
		/>
		<path
			d="M12 24C12 25.5759 12.3104 27.1363 12.9134 28.5922C13.5165 30.0481 14.4004 31.371 15.5147 32.4853C16.629 33.5996 17.9519 34.4835 19.4078 35.0866C20.8637 35.6896 22.4241 36 24 36C25.5759 36 27.1363 35.6896 28.5922 35.0866C30.0481 34.4835 31.371 33.5996 32.4853 32.4853C33.5996 31.371 34.4835 30.0481 35.0866 28.5922C35.6896 27.1363 36 25.5759 36 24C36 20.8174 34.7357 17.7652 32.4853 15.5147C30.2348 13.2643 27.1826 12 24 12C20.8174 12 17.7652 13.2643 15.5147 15.5147C13.2643 17.7652 12 20.8174 12 24Z"
			stroke="#0069CB"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M24.0004 17.1411V24L29.1415 23.9983"
			stroke="#0069CB"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const Fairness = (props) => (
	<svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x="0.5" width="48" height="48" rx="12" fill="#E6F3FF" />
		<path
			d="M24.5 14.5H14C13.7348 14.5 13.4804 14.6054 13.2929 14.7929C13.1054 14.9804 13 15.2348 13 15.5V36.5C13 36.7652 13.1054 37.0196 13.2929 37.2071C13.4804 37.3946 13.7348 37.5 14 37.5H24.5V14.5Z"
			fill="white"
		/>
		<path
			d="M36 14.9998C36 14.7237 35.7761 14.4999 35.5 14.5H25.5C24.5 14.5 24.5 14.4998 24.5 14.4998C-nan -nan -nan -nan 24.5 15.5V36.4999C24.5 36.7265 24.5 37.2962 24.5 37.4569C24.5 37.4857 24.5143 37.4997 24.543 37.4998C24.6228 37.4999 24.8504 37.4999 25.5 37.4998L35.5 37.5C35.7762 37.4999 36 37.276 36 36.9998V14.9998Z"
			fill="#B9DDFE"
		/>
		<path
			d="M32.0858 19.8422C32.4412 20.8201 32.7615 21.7112 33.0872 22.5995C33.8329 24.6255 34.6459 26.629 35.3081 28.683C35.7254 29.9804 35.4427 31.2694 34.6486 32.3791C34.4583 32.626 34.2156 32.8236 33.9396 32.9564C33.6635 33.0891 33.3616 33.1534 33.0576 33.1441C31.8381 33.1749 30.616 33.1889 29.3965 33.1441C28.177 33.0992 27.3856 32.1969 27.1325 30.7034C26.9587 29.7619 27.0523 28.7882 27.4017 27.9012C28.352 25.4353 29.2269 22.9386 30.1314 20.4558C30.196 20.2793 30.2499 20.0999 30.3306 19.8534C29.0385 19.8534 27.7894 19.8534 26.543 19.8534C26.4434 19.8534 26.3411 20.0355 26.2442 20.1336C25.9854 20.466 25.694 20.7693 25.3747 21.0387C25.2666 21.0941 25.1768 21.1818 25.1169 21.2907C25.0569 21.3995 25.0295 21.5244 25.0382 21.6495C25.0382 26.1779 25.0382 30.7071 25.0382 35.2373C25.0382 35.3886 25.0543 35.5427 25.0678 35.7501H29.1973C29.7142 35.7501 30.0399 36.0023 30.0049 36.3918C29.9511 36.8597 29.6442 37.0055 29.2188 36.9998C28.064 36.9998 26.9091 36.9998 25.7542 36.9998H19.7296C19.2181 36.9998 18.8897 36.7477 18.922 36.361C18.9704 35.8874 19.2773 35.7473 19.7053 35.7501C20.8925 35.7501 22.0797 35.7501 23.2695 35.7501H23.8483C23.8483 35.5315 23.8752 35.3606 23.8752 35.1896C23.8752 30.695 23.8752 26.2003 23.8752 21.7056C23.8929 21.5639 23.8674 21.42 23.8021 21.2943C23.7369 21.1685 23.6353 21.0674 23.5118 21.0051C23.1854 20.7987 22.909 20.5168 22.7042 20.1812C22.6536 20.0685 22.5716 19.9743 22.4689 19.9108C22.3661 19.8474 22.2474 19.8176 22.1281 19.8253C20.9733 19.8422 19.8211 19.8253 18.5908 19.8253C18.6689 20.0747 18.7255 20.2821 18.7981 20.4782C19.7996 23.2048 20.8737 25.9004 21.7593 28.6634C21.9595 29.2965 22 29.9725 21.877 30.6266C21.7539 31.2807 21.4715 31.8909 21.0567 32.3987C20.8646 32.6316 20.625 32.8171 20.3554 32.9417C20.0858 33.0663 19.7929 33.1268 19.498 33.1188C18.2759 33.1469 17.0537 33.1581 15.8342 33.1188C14.7278 33.0796 13.9499 32.3314 13.6807 31.0789C13.3987 30.0569 13.4479 28.9668 13.8206 27.9769C14.8086 25.4913 15.6889 22.9582 16.6095 20.4446C16.6742 20.2681 16.7334 20.0915 16.8222 19.8281C16.5126 19.8281 16.2677 19.8281 16.0146 19.8281C15.4762 19.8281 15.207 19.6068 15.2259 19.1864C15.2555 18.6793 15.5893 18.5896 16.0012 18.5924C18.0255 18.5924 20.0392 18.5924 22.077 18.5924C22.2047 18.6077 22.3337 18.5808 22.4459 18.5154C22.558 18.45 22.6475 18.3495 22.7015 18.2281C22.8846 17.8987 23.1402 17.6192 23.4472 17.4127C23.5905 17.3516 23.7099 17.2421 23.786 17.1018C23.8622 16.9615 23.8908 16.7985 23.8671 16.6393C23.8443 16.2913 23.8443 15.9421 23.8671 15.5941C23.8671 15.4365 23.9273 15.2854 24.0343 15.174C24.1413 15.0626 24.2865 15 24.4378 15C24.5892 15 24.7344 15.0626 24.8414 15.174C24.9484 15.2854 25.0085 15.4365 25.0085 15.5941C25.0085 16.0116 24.9897 16.4347 25.0301 16.8466C25.0726 17.0313 25.1662 17.1988 25.2993 17.3286C25.6116 17.6789 25.9319 18.0235 26.2738 18.3402C26.418 18.4776 26.6014 18.5623 26.796 18.5812C28.8016 18.598 30.8098 18.5812 32.818 18.5952C32.9849 18.5952 33.2084 18.5616 33.2999 18.654C33.4614 18.8166 33.6606 19.094 33.6229 19.2733C33.5811 19.3943 33.5137 19.504 33.4256 19.5943C33.3375 19.6845 33.2311 19.7529 33.1142 19.7945C32.7745 19.8539 32.4292 19.8699 32.0858 19.8422ZM17.7213 20.963L14.962 28.5037H20.4806L17.7213 20.963ZM31.2163 20.963L28.4893 28.5009H33.9783C33.0657 25.9957 32.1639 23.541 31.2163 20.9574V20.963ZM28.2551 29.8123C28.212 31.474 28.7155 32.0148 30.2526 32.0064C31.0198 32.0064 31.7924 32.0064 32.5596 32.0064C33.561 31.9812 33.9056 31.6813 34.1237 30.6725C34.1802 30.4063 34.1963 30.1317 34.234 29.8319L28.2551 29.8123ZM14.744 29.8123C14.744 29.9972 14.744 30.1345 14.7682 30.269C14.8813 31.5889 15.3228 32.012 16.5907 32.0176C17.3768 32.0176 18.1628 32.0176 18.9489 32.0176C20.2438 31.998 20.8683 31.1966 20.6529 29.8207L14.744 29.8123ZM24.4998 20.0887C24.7082 20.0694 24.9029 19.9722 25.0479 19.8151C25.1928 19.658 25.2783 19.4516 25.2885 19.2341C25.2851 19.1214 25.26 19.0106 25.2147 18.9083C25.1693 18.806 25.1047 18.7142 25.0246 18.6384C24.9445 18.5625 24.8505 18.5043 24.7484 18.467C24.6462 18.4297 24.5378 18.4143 24.4298 18.4214C24.2227 18.4365 24.0292 18.534 23.8893 18.6937C23.7495 18.8533 23.6741 19.0629 23.6787 19.2789C23.6977 19.4917 23.7909 19.6898 23.9407 19.8359C24.0905 19.982 24.2865 20.066 24.4917 20.0719L24.4998 20.0887Z"
			fill="#0069CB"
		/>
	</svg>
);

export const Growth = (props) => (
	<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width="48" height="48" rx="12" fill="#E6F3FF" />
		<g clipPath="url(#clip0_929_2300)">
			<path
				d="M16.2727 30.9546H14.3409C14.2788 30.9533 14.217 30.9643 14.159 30.9869C14.1011 31.0095 14.0482 31.0433 14.0034 31.0863C13.9585 31.1294 13.9226 31.1809 13.8977 31.2378C13.8727 31.2947 13.8592 31.356 13.858 31.4182V33.3114C13.8592 33.2492 13.8727 33.1879 13.8977 33.131C13.9226 33.074 13.9585 33.0226 14.0034 32.9795C14.0482 32.9365 14.1011 32.9027 14.159 32.8801C14.217 32.8574 14.2788 32.8465 14.3409 32.8478H16.2727C16.3349 32.8465 16.3967 32.8574 16.4546 32.8801C16.5125 32.9027 16.5654 32.9365 16.6103 32.9795C16.6551 33.0226 16.691 33.074 16.716 33.131C16.7409 33.1879 16.7544 33.2492 16.7557 33.3114V31.4182C16.7544 31.356 16.7409 31.2947 16.716 31.2378C16.691 31.1809 16.6551 31.1294 16.6103 31.0863C16.5654 31.0433 16.5125 31.0095 16.4546 30.9869C16.3967 30.9643 16.3349 30.9533 16.2727 30.9546Z"
				fill="#B9DDFE"
			/>
			<path
				d="M22.0682 26.3182H20.1364C20.0742 26.3169 20.0124 26.3279 19.9545 26.3505C19.8966 26.3731 19.8437 26.4069 19.7988 26.45C19.754 26.493 19.7181 26.5445 19.6931 26.6014C19.6682 26.6584 19.6547 26.7197 19.6534 26.7819V28.675C19.6547 28.6129 19.6682 28.5516 19.6931 28.4946C19.7181 28.4377 19.754 28.3862 19.7988 28.3432C19.8437 28.3001 19.8966 28.2663 19.9545 28.2437C20.0124 28.2211 20.0742 28.2101 20.1364 28.2114H22.0682C22.1303 28.2101 22.1921 28.2211 22.2501 28.2437C22.308 28.2663 22.3609 28.3001 22.4057 28.3432C22.4506 28.3862 22.4865 28.4377 22.5114 28.4946C22.5364 28.5516 22.5499 28.6129 22.5511 28.675V26.7819C22.5499 26.7197 22.5364 26.6584 22.5114 26.6014C22.4865 26.5445 22.4506 26.493 22.4057 26.45C22.3609 26.4069 22.308 26.3731 22.2501 26.3505C22.1921 26.3279 22.1303 26.3169 22.0682 26.3182Z"
				fill="#B9DDFE"
			/>
			<path
				d="M27.8636 29.1H25.9318C25.8697 29.0987 25.8079 29.1096 25.75 29.1323C25.692 29.1549 25.6391 29.1887 25.5943 29.2317C25.5494 29.2748 25.5135 29.3262 25.4886 29.3832C25.4636 29.4401 25.4501 29.5014 25.4489 29.5636V31.4568C25.4501 31.3946 25.4636 31.3333 25.4886 31.2764C25.5135 31.2194 25.5494 31.168 25.5943 31.1249C25.6391 31.0818 25.692 31.048 25.75 31.0254C25.8079 31.0028 25.8697 30.9919 25.9318 30.9931H27.8636C27.9258 30.9919 27.9876 31.0028 28.0455 31.0254C28.1034 31.048 28.1563 31.0818 28.2012 31.1249C28.246 31.168 28.2819 31.2194 28.3069 31.2764C28.3318 31.3333 28.3453 31.3946 28.3466 31.4568V29.5636C28.3453 29.5014 28.3318 29.4401 28.3069 29.3832C28.2819 29.3262 28.246 29.2748 28.2012 29.2317C28.1563 29.1887 28.1034 29.1549 28.0455 29.1323C27.9876 29.1096 27.9258 29.0987 27.8636 29.1Z"
				fill="#B9DDFE"
			/>
			<path
				d="M33.6591 21.6819H31.7273C31.6651 21.6806 31.6033 21.6916 31.5454 21.7142C31.4875 21.7368 31.4346 21.7706 31.3898 21.8136C31.3449 21.8567 31.309 21.9082 31.284 21.9651C31.2591 22.022 31.2456 22.0833 31.2443 22.1455V24.0387C31.2456 23.9765 31.2591 23.9152 31.284 23.8583C31.309 23.8013 31.3449 23.7499 31.3898 23.7068C31.4346 23.6638 31.4875 23.63 31.5454 23.6073C31.6033 23.5847 31.6651 23.5738 31.7273 23.575H33.6591C33.7213 23.5738 33.7831 23.5847 33.841 23.6073C33.8989 23.63 33.9518 23.6638 33.9966 23.7068C34.0415 23.7499 34.0774 23.8013 34.1024 23.8583C34.1273 23.9152 34.1408 23.9765 34.142 24.0387V22.1455C34.1408 22.0833 34.1273 22.022 34.1024 21.9651C34.0774 21.9082 34.0415 21.8567 33.9966 21.8136C33.9518 21.7706 33.8989 21.7368 33.841 21.7142C33.7831 21.6916 33.7213 21.6806 33.6591 21.6819Z"
				fill="#B9DDFE"
			/>
			<path
				d="M16.7557 31.4182C16.7544 31.356 16.7409 31.2947 16.716 31.2378C16.691 31.1809 16.6551 31.1294 16.6103 31.0863C16.5654 31.0433 16.5125 31.0095 16.4546 30.9869C16.3967 30.9643 16.3349 30.9533 16.2727 30.9546H14.3409C14.2788 30.9533 14.217 30.9643 14.159 30.9869C14.1011 31.0095 14.0482 31.0433 14.0034 31.0863C13.9585 31.1294 13.9226 31.1809 13.8977 31.2378C13.8727 31.2947 13.8592 31.356 13.858 31.4182V34.6637H16.7557V31.4182Z"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22.5511 26.7819C22.5499 26.7197 22.5364 26.6584 22.5114 26.6014C22.4865 26.5445 22.4506 26.493 22.4057 26.45C22.3609 26.4069 22.308 26.3731 22.2501 26.3505C22.1921 26.3279 22.1303 26.3169 22.0682 26.3182H20.1364C20.0742 26.3169 20.0124 26.3279 19.9545 26.3505C19.8966 26.3731 19.8437 26.4069 19.7988 26.45C19.754 26.493 19.7181 26.5445 19.6931 26.6014C19.6682 26.6584 19.6547 26.7197 19.6534 26.7819V34.6637H22.5511V26.7819Z"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M28.3466 29.5636C28.3453 29.5014 28.3318 29.4401 28.3069 29.3832C28.2819 29.3262 28.246 29.2748 28.2012 29.2317C28.1563 29.1887 28.1034 29.1549 28.0455 29.1323C27.9876 29.1096 27.9258 29.0987 27.8636 29.1H25.9318C25.8697 29.0987 25.8079 29.1096 25.75 29.1323C25.692 29.1549 25.6391 29.1887 25.5943 29.2317C25.5494 29.2748 25.5135 29.3262 25.4886 29.3832C25.4636 29.4401 25.4501 29.5014 25.4489 29.5636V34.6636H28.3466V29.5636Z"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M34.142 22.1455C34.1408 22.0833 34.1273 22.022 34.1024 21.9651C34.0774 21.9082 34.0415 21.8567 33.9966 21.8136C33.9518 21.7706 33.8989 21.7368 33.841 21.7142C33.7831 21.6916 33.7213 21.6806 33.6591 21.6819H31.7273C31.6651 21.6806 31.6033 21.6916 31.5454 21.7142C31.4875 21.7368 31.4346 21.7706 31.3898 21.8136C31.3449 21.8567 31.309 21.9082 31.284 21.9651C31.2591 22.022 31.2456 22.0833 31.2443 22.1455V34.6637H34.142V22.1455Z"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.892 34.6636H35.108"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.1897 20.8367L18.7706 18.3591"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21.8055 17.9824L24.2627 19.3637"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M27.4512 19.1482L31.1738 16.3403"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M32.6932 17.0454C33.1952 17.0555 33.6808 16.8658 34.043 16.518C34.4053 16.1703 34.6146 15.6929 34.625 15.1909C34.625 14.6785 34.4215 14.1871 34.0592 13.8248C33.6969 13.4626 33.2055 13.259 32.6932 13.259C32.1808 13.259 31.6895 13.4626 31.3272 13.8248C30.9649 14.1871 30.7614 14.6785 30.7614 15.1909C30.7718 15.6929 30.9811 16.1703 31.3434 16.518C31.7056 16.8658 32.1911 17.0555 32.6932 17.0454Z"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M25.9318 22.1455C26.4339 22.1556 26.9194 21.9659 27.2817 21.6181C27.6439 21.2704 27.8532 20.793 27.8636 20.2909C27.8636 19.7786 27.6601 19.2872 27.2978 18.9249C26.9355 18.5627 26.4442 18.3591 25.9318 18.3591C25.4195 18.3591 24.9281 18.5627 24.5658 18.9249C24.2035 19.2872 24 19.7786 24 20.2909C24.0104 20.793 24.2197 21.2704 24.582 21.6181C24.9442 21.9659 25.4298 22.1556 25.9318 22.1455Z"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20.1364 18.9C20.6384 18.9101 21.1239 18.7204 21.4862 18.3727C21.8484 18.0249 22.0578 17.5475 22.0682 17.0455C22.0682 16.5331 21.8647 16.0418 21.5024 15.6795C21.1401 15.3172 20.6487 15.1136 20.1364 15.1136C19.624 15.1136 19.1326 15.3172 18.7704 15.6795C18.4081 16.0418 18.2045 16.5331 18.2045 17.0455C18.2149 17.5475 18.4243 18.0249 18.7865 18.3727C19.1488 18.7204 19.6343 18.9101 20.1364 18.9Z"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.8239 24C15.0745 24.0114 15.3249 23.9719 15.5599 23.8839C15.7949 23.7958 16.0095 23.6611 16.191 23.4877C16.3724 23.3144 16.5168 23.1061 16.6155 22.8754C16.7141 22.6447 16.765 22.3963 16.765 22.1454C16.765 21.8945 16.7141 21.6462 16.6155 21.4155C16.5168 21.1847 16.3724 20.9764 16.191 20.8031C16.0095 20.6298 15.7949 20.495 15.5599 20.407C15.3249 20.3189 15.0745 20.2794 14.8239 20.2909C14.5732 20.2794 14.3228 20.3189 14.0878 20.407C13.8529 20.495 13.6382 20.6298 13.4567 20.8031C13.2753 20.9764 13.1309 21.1847 13.0322 21.4155C12.9336 21.6462 12.8827 21.8945 12.8827 22.1454C12.8827 22.3963 12.9336 22.6447 13.0322 22.8754C13.1309 23.1061 13.2753 23.3144 13.4567 23.4877C13.6382 23.6611 13.8529 23.7958 14.0878 23.8839C14.3228 23.9719 14.5732 24.0114 14.8239 24Z"
				stroke="#0069CB"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_929_2300">
				<rect width="24" height="24" fill="white" transform="translate(12 12)" />
			</clipPath>
		</defs>
	</svg>
);
